{
  "app": {
    "name": "Aslen Ops",
    "tagline": "Stock, production and Amazon\nin one place.",
    "description": "Internal operations app of Aslen Kağıtçılık · Napelia. Invited partners only.",
    "version": "Version {{version}} · Gaziantep",
    "support": "Having trouble?",
    "supportLink": "Open a support ticket",
    "footer": "Aslen Kağıtçılık\nNapelia · {{year}}",
    "notConfigured": {
      "title": "Supabase is not configured",
      "body": "Add {{urlVar}} and {{keyVar}} to {{file}} (see README → Setup).",
      "inline": "Supabase is not configured — add {{urlVar}} and {{keyVar}} to {{file}}."
    }
  },
  "common": {
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "close": "Close",
    "back": "Back",
    "continue": "Continue",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "new": "New",
    "search": "Search",
    "searchPlaceholder": "Search contacts, invoices, transactions…",
    "all": "All",
    "yes": "Yes",
    "no": "No",
    "loading": "Loading…",
    "retry": "Try again",
    "export": "Export",
    "columns": "Columns",
    "undo": "Undo",
    "undoIn": "Undo {{seconds}}s",
    "lastUpdated": "last updated {{time}}",
    "lastSync": "last sync {{time}}",
    "estimate": "forecast",
    "why": "why?",
    "optional": "optional",
    "none": "—",
    "total": "Total",
    "note": "Note",
    "date": "Date",
    "amount": "Amount",
    "currency": "Currency",
    "status": "Status",
    "type": "Type",
    "name": "Name",
    "description": "Description",
    "category": "Category",
    "attachment": "Document",
    "photo": "Photo",
    "comingSoon": "This module opens in {{phase}}",
    "comingSoonHint": "It will be used once the company is founded. Pre-accounting and partner expenses are ready now.",
    "phase": "phase {{phase}}",
    "goAccounting": "Go to pre-accounting",
    "signOut": "Sign out",
    "online": "online",
    "live": "live",
    "readOnly": "Read-only — your role cannot make changes",
    "copied": "Copied",
    "copyLink": "Copy link",
    "keyboardHint": "esc closes · ⌘⏎ saves"
  },
  "nav": {
    "today": "Today",
    "stock": "Stock",
    "items": "Items",
    "procurement": "Procurement",
    "production": "Production",
    "amazon": "Amazon",
    "planning": "Planning",
    "costing": "Costing",
    "sales": "Sales",
    "accounting": "Accounting",
    "documents": "Documents",
    "reports": "Reports",
    "settings": "Settings",
    "stockSub": {
      "onHand": "On hand",
      "movements": "Movement ledger",
      "lots": "Lots",
      "counts": "Counts",
      "labels": "Labels"
    },
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "notifications": "Notifications",
    "account": "Account menu",
    "currencyToggle": "Reporting currency",
    "mainMenu": "Main menu",
    "phaseShort": "P{{phase}}",
    "themeLight": "Light theme",
    "themeDark": "Dark theme",
    "palette": {
      "title": "Command palette",
      "description": "Quick access to screens and actions",
      "empty": "No results",
      "actions": "Actions",
      "results": "Records",
      "go": "Go to"
    }
  },
  "auth": {
    "tabs": {
      "password": "Password",
      "magic": "Magic link",
      "invite": "Invitation"
    },
    "methodLabel": "Sign-in method",
    "welcome": "Welcome back",
    "welcomeLede": "Sign in with your e-mail and password.",
    "email": "E-mail",
    "password": "Password",
    "forgot": "Forgot password",
    "show": "Show",
    "hide": "Hide",
    "remember": "Keep me signed in on this device",
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "magicTitle": "Passwordless sign-in",
    "magicLede": "We will e-mail you a one-time link. It is valid for 15 minutes.",
    "magicSend": "Send link",
    "magicSent": "Sent.",
    "magicSentBody": "Check {{email}}. Didn't arrive?",
    "magicResend": "Send again",
    "resetSent": "Password reset link sent to {{email}}.",
    "invalidCredentials": "Wrong e-mail or password.",
    "rateLimited": "Too many attempts. Try again in a few minutes.",
    "inviteFrom": "{{name}} invited you",
    "inviteTitle": "Accept the partner invitation",
    "inviteCompany": "Company",
    "inviteRole": "Role",
    "inviteValidity": "Invitation validity",
    "inviteValidUntil": "7 days · expires {{date}}",
    "inviteRoleNote": "The partner role can write in every module; approvals can be given by either partner.",
    "inviteRoleNoteOther": "This role only sees the screens it is allowed to.",
    "yourName": "Your full name",
    "setPassword": "Set a password",
    "passwordHint": "At least {{min}} characters · {{strength}}",
    "strength": [
      "very weak",
      "weak",
      "fair",
      "good",
      "strong"
    ],
    "acceptInvite": "Accept invitation and start",
    "declineInvite": "Decline",
    "inviteMissing": "Invitation link not found. Open the link in your e-mail or ask the partner who invited you.",
    "inviteExpired": "This invitation has expired. Ask your partner for a new one.",
    "inviteUsed": "This invitation has already been used.",
    "inviteNoSession": "Sign in first to accept the invitation. If your partner created your account, use the temporary password they gave you — you will set your own password when accepting.",
    "inviteDeclined": "You declined the invitation.",
    "noCompany": "You are not a member of any company yet",
    "noCompanyLede": "Start the setup to create the company or ask your partner for an invitation.",
    "startSetup": "Start setup",
    "stats": {
      "sku": "Active SKUs",
      "marketplaces": "Marketplaces",
      "warehouses": "Warehouses"
    },
    "roles": {
      "owner": "Owner — full access",
      "partner": "Partner — full access",
      "operator": "Operator",
      "accountant_readonly": "Accountant — read-only",
      "guest": "Guest"
    }
  },
  "roles": {
    "owner": "Owner",
    "partner": "Partner",
    "operator": "Operator",
    "accountant_readonly": "Accountant",
    "guest": "Guest"
  },
  "languages": {
    "tr": "Türkçe",
    "en": "English"
  },
  "countries": {
    "TR": "Türkiye",
    "CN": "China",
    "US": "United States",
    "GB": "United Kingdom",
    "DE": "Germany",
    "FR": "France",
    "IT": "Italy",
    "ES": "Spain",
    "NL": "Netherlands"
  },
  "onboarding": {
    "title": "Aslen Ops setup",
    "lede": "Let's set up the basics in five steps. You can change every step later in Settings.",
    "progress": "Setup",
    "laterNote": "Steps marked “Connect later” show up as reminders on the Today screen.",
    "stepCounter": "Step {{n}} / {{total}}",
    "skip": "Skip setup",
    "finish": "Finish setup",
    "steps": {
      "company": {
        "title": "Company & currencies",
        "note": "Legal name, tax no, reporting currency",
        "lede": "Legal name and tax details are printed on documents. The reporting currency becomes the default of every summary."
      },
      "warehouses": {
        "title": "Warehouses",
        "note": "Your warehouse + one FBA warehouse per marketplace",
        "lede": "Define your warehouse down to locations. A separate FBA warehouse is created for every Amazon marketplace — its stock only changes through sync."
      },
      "units": {
        "title": "Units & pack sizes",
        "note": "Pieces, packs, cases, kg and conversions",
        "lede": "In the napkin business everything converts between pieces · packs · cases · kg. If these three numbers are wrong, costing and MRP are wrong too."
      },
      "taxes": {
        "title": "Tax rates",
        "note": "VAT, export and import exemptions",
        "lede": "Domestic sales and purchases carry VAT; Amazon exports are exempt. Import VAT paid at customs is tracked as deductible VAT."
      },
      "amazon": {
        "title": "Amazon connection",
        "note": "NA and EU regions · can be connected later",
        "lede": "Connect Amazon now and orders, FBA stock and payouts flow in automatically. You don't have to connect now."
      }
    },
    "company": {
      "legalName": "Legal name",
      "legalNamePlaceholder": "Aslen Kağıtçılık San. ve Tic. Ltd. Şti.",
      "brand": "Brand",
      "taxNo": "Tax number",
      "taxOffice": "Tax office",
      "yourName": "Your full name",
      "currencies": "Currencies",
      "currenciesNote": "The reporting currency is the default of every summary; the rate is frozen at entry time.",
      "autoFx": "Fetch the rate automatically at entry time",
      "autoFxSource": "frankfurter.app · fallback TCMB daily",
      "currencyNotes": {
        "TRY": "Accounting and production cost",
        "USD": "Bobbin purchases and Amazon US",
        "EUR": "Amazon EU payouts"
      },
      "currencyNames": {
        "TRY": "Turkish lira",
        "USD": "US dollar",
        "EUR": "Euro"
      }
    },
    "warehouses": {
      "own": "My warehouses",
      "add": "Add warehouse",
      "defaultName": "Main warehouse",
      "code": "Code",
      "name": "Name",
      "namePlaceholder": "Factory warehouse — Şehitkamil",
      "locations": "Locations",
      "locationsCount": "{{count}} locations",
      "noLocations": "no locations",
      "locationsSuffix": "loc.",
      "active": "active",
      "fba": "FBA warehouses",
      "fbaNote": "created automatically per marketplace — stock comes from the Amazon sync",
      "fbaName": "{{name}} warehouse",
      "sync": "sync",
      "marketplaces": "Which marketplaces do you sell on?",
      "needOne": "Define at least one warehouse",
      "remove": "Remove warehouse"
    },
    "units": {
      "chain": "Packaging hierarchy",
      "chainNote": "Every piece ↔ pack ↔ case conversion derives from these three numbers.",
      "packQty": "Per pack",
      "casePacks": "Per case",
      "napkinWeight": "Napkin weight",
      "pieces": "pcs",
      "packs": "packs",
      "gramsPerPiece": "g/pc",
      "piecesValue": "{{value}} pcs",
      "packsValue": "{{value}} packs",
      "measures": "Units of measure",
      "decimals": {
        "0": "no decimals",
        "1": "1 decimal",
        "2": "2 decimals",
        "3": "3 decimals"
      },
      "caseLine": "1 case = {{packs}} packs = {{pieces}} pcs ≈ {{kg}} kg",
      "bobbinLine": "1 bobbin = {{kg}} kg = {{cases}} cases = {{pieces}} pcs",
      "palletLine": "1 pallet = {{bobbins}} bobbins = {{kg}} kg = {{cases}} cases"
    },
    "taxes": {
      "vat": "VAT rates",
      "addRate": "Add rate",
      "default": "default",
      "scope": {
        "sale": "sales",
        "purchase": "purchases",
        "both": "sales + purchases"
      },
      "exportImport": "Exports and imports",
      "notes": {
        "amazonExport": "Amazon cross-border sales",
        "amazonExportNote": "Export exemption · no VAT",
        "importVat": "Import VAT (customs)",
        "importVatNote": "Tracked as deductible VAT",
        "customsDuty": "Import customs duty",
        "customsDutyNote": "HS 4803.00.90 · rate awaiting confirmation"
      },
      "confirm": "Rates await the accountant's confirmation"
    },
    "amazon": {
      "na": "NA region",
      "eu": "EU region",
      "notConnected": "Not connected",
      "connected": "Connected",
      "later": "Connect later",
      "connect": "Connect",
      "laterChosen": "Will connect later",
      "connectNote": "The Seller Central authorisation is granted in the Amazon module (phase 4). Until then CSV upload mode is used.",
      "csvInfo": "If you connect Amazon later, the app switches to CSV upload mode: upload order, FBA stock and payout reports manually and use the same screens. Historical CSV data is kept once the connection is set up."
    },
    "saved": "Setup step saved",
    "done": "Setup completed"
  },
  "today": {
    "title": "Today",
    "greeting": "{{date}} · good morning {{name}}",
    "greetingAfternoon": "{{date}} · good afternoon {{name}}",
    "greetingEvening": "{{date}} · good evening {{name}}",
    "syncNow": "Sync now",
    "cashPosition": "Cash position",
    "partnerBalances": "Partner accounts",
    "partnerOwed": "owed by the company to partners",
    "monthExpenses": "Expenses this month",
    "openReceivables": "Open receivables",
    "openPayables": "Open payables",
    "stockValue": "Stock value",
    "openPurchases": "Open purchases",
    "weekProduction": "Production this week",
    "laterTiles": "Stock, production and Amazon tiles are added to this row with their modules (phases 2–6).",
    "quickActions": "Quick actions",
    "alerts": "Alerts",
    "overdue": {
      "receipt": "Receipt due {{date}} · {{amount}} left",
      "payment": "Payment due {{date}} · {{amount}} left",
      "days": "{{count}} days"
    },
    "feed": "Feed",
    "noAlerts": "No alerts — all good.",
    "noFeed": "Nothing yet. Your first expense will show up here.",
    "activity": {
      "tx": {
        "expense": "added an expense — {{amount}}",
        "receipt": "recorded a receipt — {{amount}}",
        "payment": "recorded a payment — {{amount}}",
        "transfer": "made a transfer — {{amount}}",
        "income": "recorded income — {{amount}}",
        "fx_diff": "created an FX difference — {{amount}}",
        "fee": "recorded a fee — {{amount}}",
        "other": "recorded a transaction — {{amount}}"
      },
      "withNote": "{{text}} · {{note}}",
      "txDeleted": "deleted a transaction",
      "fxPosted": "FX difference posted — {{amount}}",
      "invoiceDraft": "created an invoice draft",
      "invoice": {
        "open": "posted invoice",
        "paid": "closed invoice",
        "partially_paid": "matched a partial payment to invoice",
        "cancelled": "cancelled invoice",
        "other": "updated invoice"
      },
      "invoiceLine": "{{action}} {{no}} — {{amount}}",
      "invoiceLineNoNumber": "{{action}} — {{amount}}",
      "contactAdded": "added contact — {{name}}",
      "contactUpdated": "updated contact — {{name}}",
      "accountOpened": "opened account — {{name}}",
      "accountUpdated": "updated account — {{name}}",
      "memberJoined": "joined the company",
      "memberUpdated": "membership updated"
    },
    "setupReminder": "Setup steps you postponed",
    "actions": {
      "expense": "Add expense",
      "receipt": "Record receipt",
      "payment": "Record payment",
      "invoice": "Add invoice",
      "transfer": "Transfer",
      "contact": "New contact",
      "movement": "Stock movement",
      "receiving": "Goods receipt",
      "productionOrder": "Production order",
      "fbaShipment": "FBA shipment",
      "count": "Start count"
    },
    "approvalsWaiting": "{{count}} approvals waiting",
    "moduleLater": "Comes with phase {{phase}}"
  },
  "accounting": {
    "title": "Accounting",
    "nav": {
      "contacts": "Contacts",
      "invoices": "Invoices",
      "cash": "Cash / bank",
      "partners": "Partners",
      "period": "Period summary",
      "reconciliation": "Reconciliation"
    },
    "contactTypes": {
      "customer": "customer",
      "supplier": "supplier",
      "both": "customer + supplier",
      "marketplace": "marketplace",
      "partner": "partner",
      "other": "other"
    },
    "contacts": {
      "title": "Contacts",
      "summary": "{{count}} contacts · net receivable {{receivable}} · net payable {{payable}}",
      "new": "New contact",
      "filters": {
        "all": "All",
        "customer": "Customers",
        "supplier": "Suppliers",
        "partner": "Partners",
        "overdue": "Overdue"
      },
      "columns": {
        "contact": "Contact",
        "type": "Type",
        "balance": "Balance",
        "b0_30": "0–30",
        "b31_60": "31–60",
        "b61_90": "61–90",
        "b90_plus": "90+"
      },
      "empty": "No contacts yet. Start by adding a customer or supplier.",
      "csvName": "contacts",
      "statement": "Statement",
      "statementFrom": "From",
      "statementTo": "To",
      "statementOpening": "Opening",
      "statementClosing": "Closing",
      "statementMovements": "Movements",
      "statementColumns": {
        "date": "Date",
        "doc": "Document",
        "debit": "Debit",
        "credit": "Credit",
        "balance": "Balance"
      },
      "statementEmpty": "No movement in this range. Try widening the dates.",
      "statementCsv": "statement-{{name}}",
      "searchPlaceholder": "Search name, tax no, email…",
      "balanceByCurrency": "Balance by currency",
      "receivable": "{{cur}} receivable",
      "payable": "{{cur}} payable",
      "openInvoices": "{{count}} open invoices",
      "noMovement": "no movement",
      "aging": "Aging",
      "buckets": {
        "b0_30": "0–30 days",
        "b31_60": "31–60 days",
        "b61_90": "61–90 days",
        "b90_plus": "90+ days"
      },
      "openItems": "Open items",
      "openColumns": {
        "doc": "Document",
        "date": "Date",
        "due": "Due",
        "remaining": "Remaining"
      },
      "dueIn": "{{date}} · {{days}} days",
      "dueToday": "{{date}} · today",
      "overdueBy": "{{date}} · {{days}} days overdue",
      "details": "Details",
      "fields": {
        "type": "Type",
        "name": "Legal name / name",
        "taxNo": "Tax no / ID no",
        "taxOffice": "Tax office",
        "country": "Country",
        "city": "City",
        "currency": "Default currency",
        "paymentTerms": "Payment terms (days)",
        "riskLimit": "Risk limit",
        "email": "E-mail",
        "phone": "Phone",
        "iban": "IBAN",
        "notes": "Notes"
      },
      "termsDays": "terms {{days}} days",
      "paymentTermsValue": "{{days}} days",
      "daysSuffix": "days",
      "receipt": "Record receipt",
      "payment": "Record payment",
      "addInvoice": "Add invoice",
      "saved": "Contact saved",
      "taxNoWarning": "The tax number checksum does not match — you can still save.",
      "selectHint": "Select a contact on the left"
    },
    "invoices": {
      "title": "Invoices",
      "purchase": "Purchase",
      "sale": "Sale",
      "new": "New invoice",
      "newPurchase": "New purchase invoice",
      "newSale": "New sales invoice",
      "editTitle": "Invoice {{no}}",
      "summaryPurchase": "{{count}} purchase invoices · open {{open}} · deductible VAT {{vat}}",
      "summarySale": "{{count}} sales invoices · open {{open}} · output VAT {{vat}}",
      "stats": {
        "openPayable": "Open payable",
        "paidThisMonth": "Paid this month",
        "inputVat": "Deductible VAT",
        "openReceivable": "Open receivable",
        "overdue": "Overdue",
        "collectedThisMonth": "Collected this month",
        "outputVat": "Output VAT"
      },
      "overdueCount": "{{count}} invoices",
      "columns": {
        "no": "Invoice no",
        "contact": "Contact",
        "date": "Date",
        "due": "Due",
        "amount": "Amount",
        "vat": "VAT",
        "status": "Status"
      },
      "status": {
        "draft": "Draft",
        "open": "Open",
        "partially_paid": "Partial",
        "paid_purchase": "Paid",
        "paid_sale": "Collected",
        "cancelled": "Cancelled",
        "overdue": "Overdue"
      },
      "fields": {
        "no": "Invoice no",
        "noAuto": "Automatic on save ({{pattern}})",
        "date": "Invoice date",
        "due": "Due date",
        "dueDays": "{{days}} days",
        "currencyRate": "Currency · rate",
        "contact": "Contact",
        "notes": "Note"
      },
      "lines": "Lines",
      "lineColumns": {
        "item": "Item",
        "qty": "Qty",
        "unit": "Unit",
        "price": "Unit price",
        "discount": "Disc. %",
        "vat": "VAT",
        "total": "Amount",
        "product": "Product",
        "productNone": "No product",
        "productSearch": "Search products…"
      },
      "discountSuffix": "% disc.",
      "addLine": "+ Add line",
      "needLine": "Enter at least one line",
      "attachments": "Attachments",
      "attach": "PDF / photo",
      "hasAttachment": "has attachment",
      "totals": {
        "subtotal": "Subtotal",
        "discount": "Discount",
        "net": "Net total",
        "vat": "VAT",
        "vatAt": "VAT {{pct}}%",
        "total": "Total",
        "base": "TRY equivalent"
      },
      "allocations": "Payment matching",
      "remaining": "Remaining",
      "rateFrozen": "Rate frozen on the invoice date · {{rate}}",
      "draft": "Draft",
      "saveDraft": "Draft",
      "post": "Save invoice",
      "cancelInvoice": "Cancel invoice",
      "cancelConfirm": "{{no}} will be cancelled: {{total}}. This cannot be undone.",
      "saved": "Invoice saved",
      "empty": "No invoices of this type. Create the first one with “New invoice”.",
      "csvNamePurchase": "purchase-invoices",
      "csvNameSale": "sales-invoices",
      "searchPlaceholder": "Search invoice no, contact…",
      "lockedPaid": "Lines of an invoice with matched payments cannot change.",
      "lineIncomplete": "Line {{n}} is missing its description or quantity — the total above counts it",
      "deleteDraft": "Delete draft",
      "deleteDraftConfirm": "This draft invoice will be deleted. It has no posted movement yet.",
      "draftDeleted": "Draft deleted",
      "matchedPayment": "Matched payment",
      "advance": "Advance",
      "noAdvances": "This contact has no advance to match. Enter a receipt or a payment from the cash screen.",
      "allocTooBig": "A match cannot exceed what is left on the invoice — {{amount}} remaining",
      "allocLegNeeded": "Enter the {{currency}} amount that leaves the account",
      "allocLegTooBig": "The payment does not have that much left — {{amount}} remaining",
      "receipt": {
        "title": "Goods receipt",
        "badge": "{{count}} line(s) received · {{date}}",
        "hint": "{{count}} line(s) will be taken into stock. The unit cost is read from the invoice price (net of VAT and discount) at the invoice's own rate.",
        "noItemLines": "No line carries an item, so there is nothing to take into stock.",
        "receivedHint": "The goods are in stock. The unit cost came from this invoice.",
        "location": "Location",
        "date": "Receipt date",
        "action": "Take into stock",
        "undo": "Undo goods receipt",
        "done": "{{count}} line(s) taken into stock.",
        "doneWithSkipped": "{{count}} line(s) taken into stock, {{skipped}} skipped (no item or service).",
        "undone": "{{count}} line(s) reversed out of stock."
      }
    },
    "cash": {
      "title": "Cash / bank",
      "accounts": "Accounts",
      "totalBase": "Total equivalent {{amount}}",
      "totalBaseMissingRate": "an account has no rate",
      "addAccount": "+ Add account",
      "newAccount": "New account",
      "editAccount": "Edit account",
      "closed": "closed · {{date}}",
      "closedNoDate": "closed",
      "closedSubtitle": "Closed account · history only",
      "subtitle": "{{detail}} · {{count}} transactions this month",
      "lastMovement": "last movement {{date}}",
      "importStatement": "Import statement",
      "csvName": "account-{{name}}",
      "searchPlaceholder": "Search transaction, contact, category…",
      "newTx": "New transaction",
      "columns": {
        "date": "Date",
        "type": "Type",
        "description": "Description",
        "category": "Category",
        "amount": "Amount",
        "balance": "Balance"
      },
      "txTypes": {
        "receipt": "Receipt",
        "payment": "Payment",
        "transfer": "Transfer",
        "expense": "Expense",
        "income": "Income",
        "fee": "Fee",
        "fx_diff": "FX difference"
      },
      "txForm": {
        "type": "Transaction type",
        "account": "Account",
        "sourceAccount": "Source account",
        "amount": "Amount",
        "currency": "Currency",
        "partnerCurrencyNew": "The {{currency}} partner account is opened on save. The amount is kept in {{currency}}; its TRY value is frozen at the transaction rate.",
        "contactReceivable": "Contact (receivable)",
        "contactPayable": "Contact (payable)",
        "targetAccount": "Target account",
        "targetAmount": "Amount credited to target",
        "vendor": "Vendor / person",
        "relatedAccount": "Related account",
        "category": "Category",
        "note": "Note",
        "document": "Document",
        "save": "Save transaction",
        "fxRate": "Rate (1 {{cur}} = ? TRY)",
        "fxLive": "live rate · {{source}}",
        "fxDirection": "Direction",
        "gain": "FX gain",
        "loss": "FX loss",
        "splitVat": "Split VAT at {{pct}}% ({{amount}})",
        "matchInvoices": "Match open invoices",
        "noOpenInvoices": "This contact has no open invoices — the transaction stays as an advance.",
        "unallocated": "Unmatched: {{amount}}",
        "vatRate": "VAT rate",
        "accountLeg": "Off the account ({{currency}})",
        "beforeOpening": "The account was opened on {{date}} — nothing can be booked before that",
        "accountLegHint": "For an invoice in another currency the second box is the {{currency}} leaving the account; the FX difference is booked for you.",
        "accountLegRequired": "Enter the {{currency}} amount leaving the account for a cross-currency match",
        "partnerTransferHint": "Use Transfer to reimburse a partner or record capital from a partner.",
        "saved": "Transaction saved",
        "deleted": "Transaction deleted"
      },
      "empty": "No transactions in this account yet.",
      "noAccounts": "No cash or bank accounts yet. Add the first one.",
      "accountTypes": {
        "cash": "Cash",
        "bank": "Bank",
        "payment_provider": "Payment provider",
        "partner": "Partner account"
      },
      "accountFields": {
        "name": "Account name",
        "namePlaceholder": "Ziraat · TRY current account",
        "type": "Type",
        "currency": "Currency",
        "openingBalance": "Opening balance",
        "openingDate": "Opening date",
        "bankName": "Bank",
        "iban": "IBAN",
        "lockedHint": "The account has movements: currency, opening balance and date are fixed now. Correct it with a transaction."
      },
      "partnerNote": "negative balance = the company owes the partner",
      "closeAccount": "Close account",
      "closeAccountConfirm": "{{name}} will be closed. A closed account takes no new transactions; its history stays.",
      "closeAccountNonZero": "Balance is {{amount}} — cleaner to zero it with a transfer before closing.",
      "accountClosed": "Account closed",
      "reopenAccount": "Reopen account",
      "accountReopened": "Account reopened",
      "accountSaved": "Account saved",
      "deleteTx": "Delete transaction",
      "deleteTxConfirm": "The {{amount}} transaction of {{date}} will be deleted. Matches are removed.",
      "systemFx": "FX difference rows are created automatically by matching."
    },
    "partners": {
      "title": "Partners",
      "lede": "Money partners spent personally for the company, money they put in and reimbursements — before and after incorporation.",
      "contributed": "Net contribution",
      "totalBase": "TRY equivalent",
      "approxToday": "≈ {{amount}} at today’s rate",
      "currencyLine": "{{amount}} · ≈ {{base}}",
      "share": "Share",
      "fairShare": "Share of total",
      "difference": "Difference",
      "settlement": "Suggested settlement",
      "settlementNone": "Partners are balanced — no settlement needed.",
      "pays": "{{from}} → {{to}}",
      "sharesInvalid": "Shares do not add up to 100%. Edit the partner shares.",
      "editShares": "Edit shares",
      "addExpense": "Add partner expense",
      "reimburse": "Reimburse partner (transfer)",
      "capital": "Money from partner (transfer)",
      "positive": "owed by company",
      "negative": "owed by partner",
      "history": "Movements",
      "csvName": "partner-movements",
      "sharesSaved": "Shares saved",
      "equalSplit": "equal split",
      "estimateNote": "Partners without a share split the remainder equally.",
      "breakdown": "Spending breakdown",
      "breakdownLede": "Expenses partners paid out of pocket, by category · TRY at the transaction rate",
      "allPartners": "All partners",
      "noExpenses": "No partner expenses for this selection.",
      "uncategorised": "Uncategorised",
      "entries": "{{count}} entries",
      "costOfMoney": "Cost of money",
      "costOfMoneyLede": "This month · not a legal expense",
      "costOfMoneyNone": "Nothing accrued this month.",
      "costOfMoneySetup": "Enter a reference rate"
    },
    "period": {
      "title": "Period summary",
      "quarter": "Q{{q}} {{year}}",
      "vat": "VAT summary",
      "vatNote": "output vs deductible",
      "vatCards": {
        "out": "Output VAT",
        "in": "Deductible VAT",
        "net": "VAT payable",
        "carry": "VAT carried forward"
      },
      "vatNotes": {
        "out": "from issued sales invoices",
        "in": "from purchase invoices and expenses",
        "carryFrom": "carried over from {{month}}",
        "carryNone": "nothing carried over",
        "carryOut": "{{amount}} carries into the next period",
        "due": "filing deadline {{date}}"
      },
      "byRate": "By rate",
      "base": "Base",
      "rateDirections": {
        "out": "sales",
        "in": "purchases and expenses"
      },
      "rateExempt": "exempt",
      "expensesByCategory": "Income / expense by category",
      "cashflow": "Cash flow projection",
      "cashflowRange": "{{count}} weeks · TRY",
      "cashflowNote": "Open receivables − open payables · all cash and bank accounts at their TRY value · Amazon payouts and planned purchases are added in phase 7",
      "cashflowAria": "Weekly closing balance",
      "thisWeek": "This week",
      "forecast": "Forecast",
      "lowest": "Lowest point",
      "weekOf": "week of {{date}}",
      "components": {
        "title": "Projection components",
        "opening": "Opening cash",
        "receivables": "Open trade receivables",
        "payables": "Open trade payables",
        "amazon": "Expected Amazon payouts",
        "planned": "Planned purchases",
        "fixed": "Fixed costs (payroll, social security, utilities)",
        "net": "{{count}}-week net"
      },
      "week": {
        "opening": "Cash at the start of the week",
        "inflow": "Expected receipts",
        "outflow": "Expected payments",
        "closing": "Cash at the end of the week",
        "items": "Open items falling into this week",
        "noItems": "No open item falls into this week; the closing balance comes from earlier weeks.",
        "noDue": "no due date"
      },
      "exportTitle": "Accountant export",
      "exportCsv": "Export (CSV)",
      "exportLater": "XLSX + document ZIP in phase 7",
      "movements": "{{count}} movements",
      "rows": {
        "cashMovements": "Cash / bank movements",
        "withAttachment": "With document",
        "expenseTotal": "Expense total"
      },
      "csv": {
        "headers": {
          "date": "Date",
          "account": "Account",
          "type": "Type",
          "direction": "Direction",
          "amount": "Amount",
          "currency": "Currency",
          "rate": "Rate",
          "amountBase": "TRY equivalent",
          "vat": "VAT",
          "category": "Category",
          "contact": "Contact",
          "description": "Description",
          "document": "Document"
        },
        "in": "in",
        "out": "out",
        "hasAttachment": "yes",
        "fileName": "accounting-transactions-{{from}}_{{to}}.csv"
      },
      "noData": "No records in this period.",
      "capitalCost": {
        "title": "Cost of money",
        "subtitle": "What the partners' money in the business cost this period — not a legal expense",
        "colPartner": "Partner",
        "colAvgBase": "Average balance",
        "colRate": "Rate",
        "colCost": "Cost",
        "total": "Period total",
        "noRate": "no rate",
        "noRateHint": "No reference rate for this currency, so nothing was accrued.",
        "empty": "No partner money stood in the business this period.",
        "setup": "Enter a reference rate",
        "notExpense": "This figure stays out of the books and the VAT return; it is a management report only.",
        "noFx": "no FX rate",
        "noFxHint": "This currency has no month-end rate on file, so its cost is not in the base-currency total. It is counted as soon as a rate is entered.",
        "partial": "partial",
        "partialHint": "The rate does not cover the whole month; the rate shown is the balance-weighted average over the days it does."
      }
    },
    "validation": {
      "fxLoading": "Loading the exchange rate — wait a few seconds.",
      "fxMissing": "No rate found for this date — enter the rate manually."
    },
    "txDetail": {
      "title": "Transaction details",
      "account": "Account",
      "rate": "Rate",
      "base": "TRY equivalent",
      "vat": "VAT",
      "enteredBy": "Entered by",
      "enteredAt": "Entered at",
      "document": "Document",
      "openDocument": "Open document",
      "noDocument": "No document attached to this transaction.",
      "editHint": "Amount, account, rate and VAT stay as they are. To correct those, delete the transaction and enter it again.",
      "contactMatched": "Matched to an invoice — remove the match before changing the contact.",
      "previewFailed": "Preview unavailable — open the document in a new tab.",
      "delete": "Delete transaction",
      "deleteTitle": "Delete this transaction?",
      "deleteBody": "The {{type}} of {{amount}} will be deleted. Balances update; the record stays in the audit log.",
      "deleted": "Transaction deleted"
    }
  },
  "settings": {
    "title": "Settings",
    "search": "Search settings…",
    "newBadge": "new",
    "sections": {
      "company": "Company",
      "users": "Users & roles",
      "currencies": "Currencies & FX",
      "taxes": "Taxes",
      "categories": "Income / expense categories",
      "units": "Units",
      "numbering": "Numbering",
      "warehouses": "Warehouses / locations",
      "workCenters": "Work centers",
      "amazon": "Amazon accounts",
      "notifications": "Notification rules",
      "shortcuts": "Shortcuts",
      "infra": "Infrastructure budget",
      "audit": "Audit log",
      "importExport": "Import / export",
      "backup": "Backup status",
      "stock": "Stock and counting",
      "capitalCost": "Cost of capital"
    },
    "ledes": {
      "company": "Identity shown on documents and exports.",
      "users": "Both partners have full access. Operators see no costs or prices; the accountant only reads and exports.",
      "currencies": "The rate is frozen at entry; reports are never recalculated afterwards.",
      "taxes": "VAT rates. Rates are final once confirmed by the accountant.",
      "categories": "Categories used on expense and income entries. Expense categories marked “Mobile” appear as chips on the mobile Add expense screen.",
      "units": "Units of measure, their decimal precision and the packaging hierarchy. The packaging values here are the default for new items; item-specific conversions live on the item card.",
      "numbering": "Document series. The counter resets at the start of each year.",
      "warehouses": "Define your own warehouse down to location level. A separate FBA warehouse opens automatically for every Amazon marketplace — their stock only changes through the sync.",
      "infra": "Usage of hosting resources. Above 80% a warning appears on the Today screen.",
      "audit": "Every write is stored with who, when and which record. Entries cannot be deleted.",
      "shortcuts": "Everything can be done with the keyboard on desktop. The command palette reaches every action.",
      "notifications": "Which event goes to whom, through which channel.",
      "backup": "Automatic backups and the last restore test.",
      "draft": "This section opens together with its module.",
      "importExport": "The import wizard for the item list and opening stock, the upload history and the templates. Stock only changes through movements — opening stock is posted as movements too.",
      "workCenters": "The lines and machines production runs on. Product tree operations, the capacity calendar and actual cost all feed from these records.",
      "stock": "Stock status thresholds, counting rules, the undo window, the costing method and label defaults. Changes apply to new records; past movements are not recalculated.",
      "capitalCost": "What the partners' money in the business costs, accrued daily against a reference deposit rate. A management figure — not a legal expense, and never in the VAT return or the books."
    },
    "company": {
      "legalName": "Legal name",
      "legalNameNote": "Printed on invoices and quotes",
      "brand": "Brand",
      "brandNote": "On products and PDF templates",
      "taxNo": "Tax no · office",
      "address": "Address",
      "addressPlaceholder": "OSB, Şehitkamil / Gaziantep",
      "reportingCurrency": "Reporting currency",
      "saved": "Company details saved"
    },
    "fx": {
      "reportingNote": "The ₺/$ switch in the top bar",
      "transactionCurrencies": "Transaction currencies",
      "source": "Rate source",
      "sourceNote": "Free, no API key · fallback TCMB daily XML",
      "autoFetch": "Live rate fetch",
      "autoFetchNote": "Every entry uses the rate at the time of the transaction",
      "official": "Accounting rate (TCMB)",
      "officialNote": "Official rate type for reconciliation [[awaiting accountant confirmation]]",
      "officialAria": "TCMB rate type",
      "buying": "Forex buying",
      "selling": "Forex selling",
      "current": "Current rates"
    },
    "users": {
      "permission": "Permission",
      "write": "write",
      "read": "read-only",
      "none": "no access",
      "users": "Users",
      "invite": "Send invitation",
      "inviteTitle": "Invite a user",
      "inviteSent": "Invitation created",
      "inviteCreated": "Invitation created",
      "inviteNotEmailed": "The e-mail could not be sent (company e-mail is not connected yet). Send the link below yourself; it is valid for 7 days.",
      "inviteLinkNote": "If the e-mail cannot be sent, share this link yourself (valid for 7 days):",
      "pending": "pending",
      "inviteValidUntil": "Invitation link valid until {{date}}",
      "active": "active",
      "lastSeen": "last sign-in {{time}}",
      "neverSeen": "never signed in",
      "you": "you",
      "changeRole": "Change role",
      "matrix": {
        "stockView": "View stock",
        "stockMove": "Enter stock movements",
        "countOpen": "Open count sessions",
        "countApprove": "Approve count variances",
        "poCreate": "Create purchase orders",
        "poApprove": "Approve purchase orders",
        "production": "Run production orders",
        "costs": "See costs and prices",
        "amazon": "Amazon settings",
        "accounting": "Invoices and contacts",
        "export": "Period export"
      },
      "name": "Full name"
    },
    "infra": {
      "db": "Database size",
      "storage": "Document storage",
      "actions": "Actions minutes",
      "used": "{{pct}} used",
      "threshold": "threshold 80%",
      "normal": "normal",
      "watch": "watching",
      "exceeded": "threshold exceeded",
      "notMeasured": "not measured yet",
      "dbNote": "Free tier 500 MB · warning at 400 MB",
      "storageNote": "Free tier 1 GB · warning at 800 MB",
      "actionsNote": "Private repo 2,000 min/month · budget 800 min",
      "minutesPerMonth": "{{value}} min/month",
      "tables": "Largest tables",
      "rows": "{{count}} rows",
      "measuredAt": "measured {{time}}"
    },
    "numbering": {
      "next": "next {{no}}"
    },
    "audit": {
      "time": "Time",
      "user": "User",
      "action": "Action",
      "record": "Record",
      "insert": "created {{table}}",
      "update": "updated {{table}}",
      "delete": "deleted {{table}}",
      "system": "System"
    },
    "tables": {
      "companies": "company",
      "company_members": "member",
      "company_invitations": "invitation",
      "contacts": "contact",
      "invoices": "invoice",
      "invoice_lines": "invoice line",
      "transactions": "transaction",
      "payment_allocations": "match",
      "cash_accounts": "account",
      "expense_categories": "category",
      "settings": "setting",
      "warehouses": "warehouse",
      "locations": "location",
      "tax_rates": "tax rate",
      "units": "unit",
      "number_sequences": "number series",
      "notification_rules": "notification rule",
      "items": "item",
      "item_uoms": "item unit",
      "item_groups": "item group",
      "boms": "product tree",
      "bom_lines": "component",
      "bom_operations": "operation",
      "work_centers": "work centre",
      "work_center_rates": "work centre cost",
      "machines": "machine",
      "warehouse_zones": "zone",
      "lots": "lot",
      "stock_movements": "stock movement",
      "stock_counts": "stock count",
      "stock_count_lines": "count line",
      "labels": "label",
      "import_batches": "import"
    },
    "shortcutGroups": {
      "general": "General",
      "new": "New record — after n",
      "table": "Table",
      "go": "Navigate — after g"
    },
    "shortcuts": {
      "palette": "Command palette",
      "search": "Search",
      "close": "Close drawer / modal",
      "save": "Save",
      "help": "Shortcut page",
      "newExpense": "Expense",
      "newInvoice": "Invoice",
      "newContact": "Contact",
      "goToday": "Today",
      "goAccounting": "Accounting",
      "goSettings": "Settings",
      "rowDown": "Row down / up",
      "helpNote": "Opens this page from any screen."
    },
    "categories": {
      "expense": "Expense categories",
      "income": "Income categories",
      "add": "Add",
      "namePlaceholder": "New category name",
      "mobile": "Mobile",
      "system": "System",
      "archive": "Archive",
      "archived": "“{{name}}” archived — past entries keep it",
      "saved": "Category saved",
      "rename": "Rename"
    },
    "notifRules": {
      "accounting": "Accounting notifications",
      "later": "Other rules",
      "partner_activity": "A partner recorded money movement",
      "partner_activityNote": "Other partners · in-app · instant",
      "invoice_due": "Invoice due soon",
      "invoice_dueNote": "{{count}} days before due · every morning 08:00",
      "invoice_overdue": "Invoice overdue",
      "invoice_overdueNote": "Once, when the due date passes · in-app",
      "low_stock": "Stock fell below the reorder point",
      "low_stockNote": "Both partners · in-app + e-mail",
      "days_of_cover_low": "Days of cover fell below target",
      "days_of_cover_lowNote": "Owner · daily digest · threshold [[PLACEHOLDER]]",
      "po_overdue": "Purchase order is overdue",
      "po_overdueNote": "Both partners · in-app",
      "sync_failed": "Amazon sync error",
      "sync_failedNote": "Owner · in-app + e-mail",
      "approval_requested": "Record awaiting approval",
      "approval_requestedNote": "Relevant partner · instant",
      "count_variance": "Count variance threshold exceeded",
      "count_varianceNote": "Variance above 2% · owner",
      "payout_received": "Amazon payout received",
      "payout_receivedNote": "Both partners · in-app",
      "phase": "Phase {{phase}}"
    },
    "backup": {
      "daily": "Daily full backup",
      "dailyNote": "Every night at 03:00 (TRT) · GitHub Actions · encrypted with age · kept for 90 days",
      "none": "no backup yet",
      "size": "Backup size",
      "restore": "Restore",
      "restoreNote": "docs/BACKUP_RESTORE.md — testing every three months is recommended",
      "restoreValue": "in the docs"
    },
    "units": {
      "packagingTitle": "Packaging hierarchy",
      "packagingNote": "Every pcs ↔ pack ↔ case conversion in the app derives from these three numbers.",
      "packQty": "Pieces per pack",
      "casePacks": "Packs per case",
      "napkinWeight": "Napkin weight",
      "bobbinNetKg": "Bobbin net weight",
      "palletBobbins": "Bobbins per pallet",
      "container40hc": "Container (40HC)",
      "unitPieces": "pcs",
      "unitPacks": "packs",
      "unitGramsPerPiece": "g/pc",
      "unitKg": "kg",
      "unitBobbins": "bobbins",
      "unitPallets": "pallets",
      "containerLine": "1×40HC = {{pallets}} pallets = {{bobbins}} bobbins = {{tons}} t = {{cases}} cases",
      "packagingWarning": "The change only affects the default conversions of new items. The pack and case quantities of existing items stay on their item card; past movements are not recalculated.",
      "packagingSaved": "Packaging hierarchy saved",
      "listTitle": "Units of measure",
      "add": "Add unit",
      "edit": "Edit unit — {{name}}",
      "colCode": "Code",
      "colName": "Name",
      "colDecimals": "Decimals",
      "colUsage": "Usage",
      "colStatus": "Status",
      "editAria": "Edit unit",
      "inUse": "In use — on {{count}} item units",
      "inUseRefused": "Unit ‘{{name}}’ is used by {{count}} items — it cannot be deactivated.",
      "code": "Code",
      "codeHint": "Internal code: lower-case letters, digits and underscores. It cannot change once the unit is used.",
      "codePlaceholder": "e.g. box",
      "shortName": "Short name",
      "shortNamePlaceholder": "e.g. box",
      "shortNameHint": "Shown next to quantities in tables: 12 box",
      "shortNameEn": "Short name (English)",
      "shortNameEnPlaceholder": "e.g. box",
      "longName": "Description",
      "longNamePlaceholder": "e.g. Cardboard box",
      "precision": "Decimal precision",
      "precisionNone": "None",
      "precisionWarning": "Lowering the precision does not round existing quantities; it only limits new entries.",
      "usageNote": "Usage note",
      "usageNotePlaceholder": "e.g. labels, foil",
      "usageNoteHint": "A reminder of where it is used.",
      "delete": "Delete unit",
      "deleteBody": "Unit ‘{{name}}’ will be deleted. It is not used by any item.",
      "saved": "Unit saved",
      "overridesTitle": "Item-specific conversions",
      "overridesNote": "items that differ from the company defaults",
      "overridesEmpty": "Every item uses the company defaults.",
      "overrideItem": "Item",
      "overridePackQty": "Per pack",
      "overrideCasePacks": "Per case",
      "overridePalletCases": "Per pallet",
      "overrideWeight": "Grammage"
    },
    "warehouses": {
      "ownTitle": "My warehouses",
      "fbaTitle": "FBA warehouses",
      "otherTitle": "Other warehouses",
      "add": "Add warehouse",
      "edit": "Edit warehouse {{code}}",
      "editMarketplaces": "Edit marketplaces",
      "openAria": "Open warehouse {{code}}",
      "allowsNegative": "negative stock allowed",
      "back": "← Warehouses",
      "emptyTitle": "No warehouses yet",
      "emptyBody": "Define at least one warehouse before stock can be held.",
      "fbaEmpty": "No FBA warehouse yet. One opens automatically for every marketplace you sell on.",
      "fbaEmptyAction": "Choose marketplaces",
      "code": "Code",
      "codeHint": "It prefixes the location codes — e.g. D3-A-01. It cannot change once the warehouse has movements.",
      "codeTaken": "This code belongs to another warehouse.",
      "name": "Name",
      "type": "Type",
      "typeHint": "FBA warehouses open with the marketplace picker.",
      "country": "Country",
      "address": "Address",
      "matrixLabel": "Stock matrix label",
      "matrixLabelHint": "Becomes the column header in the on-hand table.",
      "allowNegative": "Allow negative stock",
      "allowNegativeNote": "When off, nothing may leave this warehouse beyond what is on hand. When on, a negative balance shows in red and raises a warning on Today.",
      "active": "Active",
      "deactivateBlocked": "Warehouse {{code}} holds stock — transfer it before deactivating the warehouse.",
      "deactivateBlockedItems": "Warehouse {{code}} holds stock of {{count}} items — transfer it before deactivating.",
      "typeLockedNote": "The warehouse has movements: code and type cannot change.",
      "delete": "Delete warehouse",
      "deleteTitle": "Delete the warehouse?",
      "deleteBody": "Warehouse {{code}} will be deleted. It has no movements; its {{count}} locations go with it.",
      "saved": "Warehouse saved",
      "deleted": "Warehouse {{code}} deleted",
      "identity": {
        "type": "Type",
        "country": "Country",
        "address": "Address",
        "matrixLabel": "Stock matrix label",
        "negative": "Negative stock",
        "negativeOn": "on",
        "negativeOff": "off",
        "locations": "Locations",
        "locationsValue": "{{active}} active · {{inactive}} inactive",
        "items": "Items on hand",
        "itemsValue": "{{items}} items · {{lots}} lots",
        "lastCount": "Last count",
        "never": "never"
      },
      "zones": {
        "eyebrow": "Zones",
        "all": "All",
        "add": "+ Add zone",
        "edit": "Zone {{code}}",
        "new": "Add zone",
        "editAria": "Edit zone",
        "code": "Code",
        "codePlaceholder": "H",
        "name": "Name",
        "namePlaceholder": "Raw materials",
        "matrixColumn": "Own column in the stock matrix",
        "matrixColumnNote": "When on, this zone gets its own column in the on-hand table.",
        "matrixLabel": "Matrix label",
        "matrixLabelPlaceholder": "D1 Raw",
        "deleteBlocked": "This zone holds {{count}} locations — move them to another zone first.",
        "none": "No zone",
        "saved": "Zone saved"
      },
      "locations": {
        "searchPlaceholder": "Search location…",
        "add": "Add location",
        "bulkAdd": "Add in bulk",
        "edit": "{{code}}",
        "new": "Add location",
        "selected": "{{count}} locations selected",
        "printLabels": "Print labels",
        "printLabelsCount": "Print labels ({{count}})",
        "labelsPending": "The label screen opens later in this phase",
        "deactivate": "Deactivate",
        "clearSelection": "Clear selection",
        "colCode": "Code",
        "colName": "Description",
        "colZone": "Zone",
        "colType": "Type",
        "colItems": "Items",
        "colLastCount": "Last count",
        "colStatus": "Status",
        "code": "Code",
        "codeHint": "Only A–Z, 0–9 and hyphens. No Turkish characters.",
        "codeTaken": "This location code already exists.",
        "zone": "Zone",
        "type": "Type",
        "quarantineHint": "Stock in quarantine does not count as available for sales or planning.",
        "name": "Description",
        "namePlaceholder": "e.g. Finished goods rack A, bay 2",
        "active": "Active",
        "deactivateBlocked": "{{code}} holds stock of {{count}} items ({{qty}}). Transfer it before deactivating.",
        "deactivateBlockedItems": "{{code}} holds stock of {{count}} items. Transfer it before deactivating.",
        "negative": "negative",
        "stockHere": "Stock in this location",
        "seeAllStock": "See all in stock →",
        "delete": "Delete location",
        "saved": "Location saved",
        "emptyTitle": "No locations in this warehouse",
        "emptyBody": "Stock is held at warehouse level; add locations to track shelves.",
        "emptyAction": "Add locations in bulk",
        "noResult": "No location matches ‘{{q}}’.",
        "noResultAction": "Clear the search",
        "footNote": "Natural order · D1-A-2 < D1-A-10 · the warehouse default location is not listed",
        "footCount": "{{visible}} / {{total}} locations · {{active}} active · {{inactive}} inactive",
        "bulkTitle": "Add locations in bulk",
        "bulkPrefix": "Prefix",
        "bulkStart": "Start",
        "bulkEnd": "End",
        "bulkPad": "Digits",
        "bulkPad2": "2 digits (01)",
        "bulkPad3": "3 digits (001)",
        "bulkPreviewTitle": "Preview",
        "bulkPreviewCount": "{{count}} locations will be created",
        "bulkPreviewEmpty": "Enter a valid range.",
        "bulkConflicts": "{{count}} already exist and will be skipped: {{codes}}",
        "bulkFixRange": "Fix the range",
        "bulkSubmit": "Create {{count}} locations",
        "bulkCreated": "{{count}} locations created"
      },
      "marketplaces": {
        "title": "FBA marketplaces",
        "subtitle": "One FBA warehouse opens for every marketplace you tick.",
        "regionNA": "NA region",
        "regionEU": "EU region",
        "hasStock": "{{code}} holds {{qty}} — it cannot be removed.",
        "saved": "Marketplaces updated"
      },
      "matrix": {
        "title": "Stock matrix columns",
        "note": "The order of the warehouse columns on the on-hand screen",
        "reorderAria": "Change the order",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "visible": "visible",
        "saved": "Column order saved"
      }
    },
    "workCenters": {
      "title": "Work centres",
      "add": "Add work centre",
      "edit": "{{name}}",
      "usedIn": "used in {{count}} active product trees",
      "missingCostTitle": "Hourly cost missing",
      "missingCostBody": "No hourly cost has been entered for {{names}}. Standard and actual cost count their machine share as ₺0.",
      "missingCostAction": "Enter the costs",
      "colWorkCenter": "Work centre",
      "colType": "Type",
      "colCapacity": "Capacity",
      "colNominalRate": "Nominal rate",
      "colHourlyCost": "Hourly cost",
      "colBomUsage": "Product trees",
      "colStatus": "Status",
      "subtotalCount": "{{count}} work centres",
      "subtotalHours": "{{hours}} h/day",
      "notEntered": "not entered",
      "emptyTitle": "No work centres yet",
      "emptyBody": "Define at least one work centre for product tree operations.",
      "types": {
        "cutting": "Cutting",
        "folding": "Folding",
        "foil_print": "Foil print",
        "digital_print": "Digital print",
        "packing": "Packing",
        "palletising": "Palletising",
        "qc": "Quality control",
        "other": "Other"
      },
      "sectionGeneral": "General",
      "sectionCapacity": "Capacity",
      "sectionCost": "Cost",
      "sectionMachines": "Machines",
      "sectionUsage": "Usage",
      "code": "Code",
      "codePlaceholder": "M2",
      "codeTaken": "This code belongs to another work centre.",
      "name": "Name",
      "namePlaceholder": "Folding M2",
      "type": "Type",
      "location": "Production location",
      "locationNone": "Not selected",
      "locationHint": "Production output and backflush consumption are booked against this location.",
      "capacityHours": "Daily capacity",
      "capacitySuffix": "h/day",
      "hourSuffix": "h",
      "workingDays": "Working days",
      "days": {
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat",
        "sun": "Sun"
      },
      "nominalRate": "Nominal rate",
      "nominalRateHint": "Planning and the efficiency report take this rate as the target.",
      "hourlyCost": "Hourly machine cost",
      "hourlyCostEmpty": "Not entered — counted as ₺0 in cost calculations.",
      "labourRate": "Default labour rate",
      "labourRateHint": "Suggested as the default on product tree operations.",
      "depreciation": "Monthly depreciation (machines)",
      "costMasked": "Cost fields are masked for the operator role.",
      "addMachine": "+ Add machine",
      "activeBoms": "Active product trees",
      "plannedThisWeek": "Planned this week",
      "deactivate": "Deactivate",
      "deactivateBlocked": "{{name}} is used in {{count}} active product trees — move those operations to another work centre first.",
      "delete": "Delete",
      "saved": "Work centre saved"
    },
    "stock": {
      "statusTitle": "Stock status",
      "criticalRatio": "Critical stock threshold",
      "criticalRatioNote": "On-hand stock shows as ‘critical’ once it falls to this share of the reorder point.",
      "negativeStock": "Negative stock",
      "negativeStockNote": "Set per warehouse.",
      "negativeStockLink": "Warehouses / locations →",
      "negativeStockOff": "off in {{count}} warehouses",
      "negativeStockOn": "on in {{count}} warehouses",
      "countTitle": "Counting",
      "countTolerance": "Variance tolerance",
      "countToleranceNote": "Variances above this share go to approval and raise a notification.",
      "countBlind": "Blind count by default",
      "countBlindNote": "The person counting does not see the expected quantity.",
      "countSelfApproval": "Approve your own count",
      "countSelfApprovalNote": "When off, the person who counted cannot approve it; the other partner does. The company owner may override this rule.",
      "movementsTitle": "Movements",
      "undoSeconds": "Undo window",
      "undoSecondsNote": "A saved movement can be undone within this window.",
      "backdateMaxDays": "Back-dating limit",
      "backdateMaxDaysNote": "Mobile and offline records may be back-dated at most this far; partners can write further back on the web.",
      "requirePhoto": "Photo required for scrap and damage",
      "costingTitle": "Costing",
      "costingBadge": "owner · partner · accountant",
      "costingMethod": "Costing method",
      "costingMethodNote": "The method is company-wide.",
      "costingMovingAverage": "Moving average",
      "costingFifo": "FIFO",
      "overheadPct": "Overhead rate",
      "overheadPctNote": "Added to the standard cost. Counted as 0 until it is entered.",
      "driftWarnPct": "Standard cost drift warning",
      "driftWarnPctNote": "When the cost computed from the product tree drifts further than this, the item card shows a warning.",
      "itemDefaultsTitle": "Item defaults",
      "bomBaseQty": "Product tree base quantity",
      "napkinStockUnit": "Napkin stock unit",
      "bobbinStockUnit": "Bobbin stock unit",
      "itemDefaultsNote": "New items show their on-hand figure in this unit.",
      "labelsTitle": "Labels",
      "labelsBadge": "{{dpi}} dpi thermal",
      "labelsFootNote": "The label carries the QR, lot no, item name, SKU, quantity + unit and the production date. No expiry and no GTIN in this phase.",
      "labelLogo": "Print the logo",
      "labelMargin": "Margin",
      "labelPrinterDpi": "Printer resolution",
      "labelPrinterDpiNote": "[[Zebra ZD230 class]] thermal — the printer has not been bought yet.",
      "labelQrEcc": "QR error correction",
      "labelQrEccNote": "A higher level makes a worn label easier to read.",
      "labelCopies": "Default copies",
      "mobileTitle": "Mobile",
      "mobileShowCost": "Show cost on the item card",
      "mobileShowCostNote": "Only for roles that may see costs; the operator never does.",
      "openingTitle": "Opening stock",
      "openingBadgeOpen": "open",
      "openingFootNote": "After the lock, corrections are only made with a stock count.",
      "openingLabel": "Opening stock lock",
      "openingOpenNote": "Opening stock movements and import are open. Lock them once you go live.",
      "openingLock": "Lock opening stock",
      "openingLockedChip": "locked · {{date}} · {{who}}",
      "openingLockedAt": "locked · {{date}}",
      "openingLockedNote": "Corrections are made with a stock count.",
      "openingLockedInfo": "The opening stock card in Import / export is disabled, and a movement can no longer carry the ‘Opening stock’ reason.",
      "openingLockOwnerOnly": "Only the company owner can lock it.",
      "openingConfirmTitle": "Lock opening stock?",
      "openingConfirmBody": "Once locked, no movement may carry the ‘Opening stock’ reason and the opening import closes; corrections are made with a stock count.",
      "openingConfirmSummary": "{{warehouses}} warehouses · {{counts}} count sessions · {{value}}",
      "openingConfirmWarehouses": "Warehouses to lock",
      "openingConfirmWarehousesValue": "{{count}} warehouses · {{codes}}",
      "openingConfirmCounts": "Opening count session",
      "openingConfirmMovements": "Opening movements",
      "openingConfirmMovementsValue": "{{count}} movements",
      "openingConfirmValue": "Total value to lock",
      "openingConfirm": "Lock",
      "openingLocked": "Opening stock locked",
      "openingLockedServer": "Opening stock is locked — use a stock count to correct it",
      "placeholderBadge": "placeholder",
      "placeholderHint": "This value is not confirmed yet; the system default is in use.",
      "notEntered": "not entered",
      "phase7": "Phase 7",
      "saved": "Stock settings saved",
      "saveFailed": "Could not be saved. Check your connection and try again.",
      "suffixDays": "days",
      "suffixSeconds": "s",
      "suffixMm": "mm",
      "suffixDpi": "dpi",
      "suffixPieces": "pcs"
    },
    "capitalCost": {
      "explainer": "Money the partners leave in the business would earn interest in a deposit account. This section holds the reference rate it is measured against: every partner's contribution accrues daily and is reported as the cost of money.",
      "points": {
        "base": "Base: what each partner has in the business — out-of-pocket expenses and paid-in capital alike. A partner who owes the company accrues nothing.",
        "method": "Method: simple interest, ACT/365, on each day's balance at that day's rate. No compounding.",
        "currency": "Each currency uses its own rate. Without a rate for a currency nothing is accrued on it and the screen says so.",
        "notExpense": "This is not a legal expense: it never touches cash, bank, contact or VAT records and stays apart in the accountant export. Turkey's notional interest deduction on cash capital increases is a different calculation — ask your accountant."
      },
      "ratesTitle": "Reference rates",
      "add": "Add rate",
      "empty": "No reference rate yet. Nothing is accrued until one is entered.",
      "missingRate": "No reference rate for: {{currencies}}. Nothing is accrued on that money.",
      "colCurrency": "Currency",
      "colFrom": "In force from",
      "colRate": "Annual rate",
      "colNote": "Source / note",
      "inForce": "in force",
      "drawerTitle": "Reference rate",
      "fromHint": "Applies from this day on; earlier days keep the previous rate.",
      "rateHint": "A bank's term deposit rate, gross per year. E.g. 42.5.",
      "noteHint": "Where the rate came from — the answer to “where did this number come from” later.",
      "notePlaceholder": "Garanti · 32-day term · 1 Oct 2026",
      "saved": "Rate saved",
      "deleted": "Rate deleted",
      "deleteTitle": "Delete this rate?",
      "deleteBody": "The days it covered fall back to the previous rate, and past reports are recomputed.",
      "future": "future-dated"
    }
  },
  "states": {
    "emptyTitle": "Nothing here yet",
    "error": "Could not load the data",
    "errorBody": "The server cannot be reached. Check your connection — nothing unsaved was lost.",
    "offline": "Offline — entries are queued",
    "offlineQueue": "{{count}} pending",
    "readOnly": "Read-only",
    "readOnlyTitle": "Read-only access — accountant role",
    "readOnlyBody": "You cannot create or change records. Exports and statements stay open to you.",
    "readOnlyExport": "Export the period",
    "forbidden": "You are not allowed to see this section",
    "forbiddenBody": "Your role: {{role}}. Ask your partner for access."
  },
  "mobile": {
    "tabs": {
      "today": "Today",
      "stock": "Stock",
      "scan": "Scan",
      "production": "Production",
      "more": "More",
      "accounting": "Accounting"
    },
    "pullToRefresh": "Last sync {{time}} · pull to refresh",
    "tapToRefresh": "Last sync {{time}} · tap to refresh",
    "more": {
      "title": "More",
      "notifications": "Notifications",
      "settings": "Settings",
      "expense": "Add expense",
      "approvals": "Approvals",
      "amazon": "Amazon summary",
      "count": "Stock count",
      "receiving": "Goods receipt",
      "fba": "FBA shipment",
      "documents": "Company documents"
    },
    "settings": {
      "account": "Account",
      "company": "Company",
      "preferences": "Preferences",
      "language": "Language",
      "reportingCurrency": "Reporting currency",
      "darkMode": "Dark theme",
      "darkModeNote": "follows the system setting",
      "darkModeWeb": "in the browser it follows the phone’s theme setting",
      "bigText": "Large text",
      "bigTextNote": "in shop-floor mode",
      "notifications": "Notifications",
      "stockAlerts": "Stock alerts",
      "approvalRequests": "Approval requests",
      "syncErrors": "Amazon sync errors",
      "dailyDigest": "Daily digest",
      "dailyDigestNote": "every evening at 20:00",
      "signOut": "Sign out",
      "signOutPending": "Unsent records on this device: {{count}} (expenses, stock movements, counts). Signing out deletes them. Tap Cancel to connect and send them first.",
      "signOutPendingSome": "Unsent records on this device: {{count}} (expenses, stock movements, counts). Signing out deletes the {{mine}} you added; the rest were queued by an earlier version and stay on the device. Tap Cancel to connect and send them first.",
      "signOutPendingKept": "Unsent records on this device: {{count}} (expenses, stock movements, counts). All of them were queued by an earlier version: signing out leaves them on the device. Tap Cancel to connect and send them first.",
      "signOutCounts": "Counts in progress on this device: {{count}} session(s), {{lines}} counted lines. Signing out deletes them from this device — unsent lines go with them."
    },
    "expense": {
      "title": "Add expense",
      "receiptPhoto": "receipt\nphoto",
      "takePhoto": "Take photo",
      "pickGallery": "Choose from gallery",
      "pickFile": "Choose a file (PDF / image)",
      "amount": "Amount",
      "currency": "Currency",
      "category": "Category",
      "account": "Paid from",
      "note": "Note",
      "notePlaceholder": "What was it for?",
      "splitVat": "Split VAT at {{pct}}% ({{amount}})",
      "save": "Save expense",
      "saved": "Expense saved",
      "queued": "Offline — expense queued",
      "queueFailed": "The expense could not be stored on this device (storage may be full). Keep this screen open and save again once you are online.",
      "fxMissing": "No {{currency}} rate found, and the rate service did not answer either. Enter the rate on the web, then send again.",
      "photoFailed": "The photo could not be taken. Try picking one from the gallery, or save the expense without it.",
      "pickFailed": "The photo could not be picked. Try again, or save the expense without it.",
      "cameraDenied": "Camera permission denied. You can pick from the gallery.",
      "noAccount": "Define a cash or partner account on the web first."
    },
    "entry": {
      "noRights": "Booking an entry needs owner or partner rights. In this role you can read records but not add them.",
      "today": "today",
      "todayCta": "Back to today",
      "prevMonth": "Previous month",
      "nextMonth": "Next month",
      "weekdayShort": {
        "mon": "Mo",
        "tue": "Tu",
        "wed": "We",
        "thu": "Th",
        "fri": "Fr",
        "sat": "Sa",
        "sun": "Su"
      },
      "pickAccount": "Pick an account",
      "pickTargetAccount": "Pick the target account",
      "pickContact": "Pick a contact",
      "pickCategory": "Pick a category",
      "searchContact": "Name, tax no, city",
      "searchCategory": "Search categories",
      "noResults": "No results: “{{query}}”",
      "noContacts": "No contacts yet. Add one with “New contact”.",
      "noCategories": "No categories of this kind yet. Add one on the web under Settings → Income / expense categories; the ones you flag as “On mobile” show up here as chips.",
      "categoriesLoading": "Loading categories…",
      "categoriesFailed": "Categories could not be loaded — which ones exist is unknown.",
      "otherCategories": "Other…",
      "newContactOffline": "A new contact needs a connection — contacts are not carried by the offline queue. Add it once you are online.",
      "targetAmountHint": "Source and target currencies differ: you give the amount that lands in the target account, and the program books the FX difference.",
      "fxDiffNote": "An FX difference moves no money out of the account: the amount only corrects its base-currency value, and the direction says whether it is a gain or a loss.",
      "fxPastDate": "{{currency}} account — a backdated entry needs that day's rate. With no rate on file for it the entry waits in the queue; enter the rate on the web under Settings → Currencies & rates.",
      "fxMissingForDate": "No {{currency}} rate on file for {{date}}, and a past day's rate cannot be fetched afterwards. Enter it on the web under Settings → Currencies & rates, then send again.",
      "matchLoading": "Loading open invoices…",
      "matchFailed": "The open-invoice list could not be loaded — whether this contact has open invoices is unknown. Try again; saved without a match, the entry stays an advance.",
      "matchOffline": "Offline — the open-invoice list may be out of date, so matching is off. The entry is queued as an advance; match it to the invoice once you are back online.",
      "matchRateUnknown": "An invoice in another currency cannot be matched from the phone with a {{currency}} account: the rate is only resolved when the entry is sent. Save it as an advance and match it on the web.",
      "advance": "stays as an advance and can be matched to an invoice later",
      "overAllocated": "What is spread across the invoices exceeds the entry by {{amount}} — lower the amounts on the rows.",
      "queued": "Offline — entry queued",
      "queuedAdvance": "Offline — the entry was queued as an advance. Match it to the invoice once you are back online.",
      "queuedMatched": "Offline — the entry was queued with its matches. If the invoice closed in the meantime it waits in the queue; you will see it under “Pending changes”.",
      "queueFailed": "The entry could not be stored on this device (storage may be full). Keep this screen open and save again once you are online."
    },
    "scanSoon": "The barcode scanner opens with the stock module in phase 2.",
    "scan": {
      "subtitle": "Scan a QR code or barcode",
      "offlineShort": "Offline",
      "manual": "Enter manually",
      "torch": "Torch",
      "history": "Recent scans",
      "historyEmpty": "No scans yet.",
      "clear": "Clear",
      "onHand": "On hand",
      "location": "Location",
      "cost": "Cost",
      "hidden": "hidden",
      "shelves": "shelves",
      "costHiddenNote": "Cost fields are hidden for the operator role.",
      "costHiddenA11y": "Cost hidden — operator role",
      "cameraA11y": "Camera view — align the barcode in the frame",
      "maybe": "Did you mean?",
      "lotBlocked": "This lot is quarantined — it cannot be issued.",
      "screenSoon": "This screen opens later in phase 2.",
      "notFound": "No match",
      "notFoundBody": "“{{code}}” matched no item, lot, location or order.",
      "notFoundBarcode": "Barcode “{{code}}” is not linked to any item.",
      "docMissing": "“{{code}}” was not found in this company.",
      "rescan": "Scan again",
      "linkBarcode": "Link barcode to item",
      "linkBarcodeLater": "Linking a barcode opens on the phone later in phase 2. You can add the barcode to the item on a computer.",
      "mismatch": "This is a {{found}} label — scan a {{expected}}.",
      "counter": "{{count}} scanned",
      "done": "Done",
      "offlineData": "offline · data from {{time}}",
      "offlineRecord": "Offline — this record loads when you are back online.",
      "resolveError": "Lookup failed.",
      "manualTitle": "Enter code manually",
      "manualPlaceholder": "Lot, SKU, location or order no.",
      "actions": {
        "transfer": "Transfer",
        "count": "Count",
        "printLabel": "Print label",
        "useInProduction": "Use in production",
        "stockCard": "Stock card",
        "transferFrom": "Transfer from here",
        "viewContents": "View contents",
        "receive": "Receive goods",
        "shopFloor": "Shop-floor mode",
        "continueCount": "Continue count"
      },
      "facts": {
        "items": "Items",
        "lots": "Lots",
        "lastMove": "Last movement"
      },
      "kinds": {
        "item": "item",
        "lot": "lot",
        "location": "location",
        "document": "document",
        "purchase_order": "order",
        "production_order": "production order",
        "stock_count": "count",
        "stock_movement": "movement",
        "fba_shipment": "FBA shipment"
      },
      "kindTitle": {
        "purchase_order": "Purchase order",
        "production_order": "Production order",
        "stock_count": "Count session",
        "stock_movement": "Stock movement",
        "fba_shipment": "FBA shipment"
      },
      "phaseLocked": {
        "receive": "Goods receipt arrives in phase 3.",
        "shopFloor": "Shop-floor mode arrives in phase 5.",
        "fba": "FBA shipments arrive in phase 4."
      },
      "permission": {
        "body": "The scanner needs camera access. Without it you can enter the barcode manually.",
        "allow": "Allow",
        "blockedBody": "Camera access is off. Turn it on in Settings or enter the barcode manually.",
        "openSettings": "Open Settings",
        "unavailable": "The camera could not start. Enter the barcode manually."
      },
      "unknown": "Code not recognised: {{code}}"
    },
    "label": {
      "later": "Label printing opens later in phase 2.",
      "laterBody": "The 100 × 50 mm thermal label — QR, lot number, item and quantity — comes in a later round. Until then this screen prints nothing; counting and transfers are unaffected."
    },
    "stock": {
      "title": "Stock",
      "searchPlaceholder": "Search item, SKU, lot or location",
      "scan": "Scan barcode",
      "clear": "Clear search",
      "filters": {
        "all": "All",
        "finished": "Finished",
        "raw": "Raw material",
        "packaging": "Packaging"
      },
      "resultCount": "{{count}} results · “{{query}}”",
      "itemCount": "{{count}} items",
      "matchLot": "lot {{lot}}",
      "rowA11yQty": "on hand {{qty}} {{unit}}",
      "rowA11yHint": "Opens the item card",
      "onHand": "On hand",
      "locations": "Locations",
      "shelves": "shelves",
      "lots": "Lots",
      "activeLots": "active",
      "noLots": "no lots",
      "byLocation": "By location",
      "lotsTitle": "Lots",
      "movements": "Last movements",
      "noMovements": "No movements yet",
      "perUnit": "{{factor}} {{base}}/{{unit}}",
      "fba": "FBA {{code}}",
      "actions": {
        "transfer": "Transfer",
        "adjust": "Adjust",
        "label": "Label"
      },
      "costHidden": "Cost and sales price hidden",
      "roleSuffix": "{{role}} role",
      "unitCost": "Unit cost",
      "stockValue": "Stock value",
      "status": {
        "low": "Low",
        "critical": "Critical",
        "negative": "Negative"
      },
      "empty": "No items yet",
      "emptyBody": "Items are added on the web, in Items.",
      "noResults": "No results for “{{query}}”",
      "noResultsFilter": "No items under this filter",
      "noResultsBody": "Search by SKU, name, lot or location code, or scan a barcode.",
      "scanAction": "Scan",
      "loadError": "Could not load stock",
      "noCache": "No stock data on this device",
      "noCacheBody": "Open it once while online; after that it is searchable offline too.",
      "noAccess": "This section is closed to your role",
      "noAccessBody": "Stock screens are visible to owner, partner and operator roles.",
      "itemGone": "The item is no longer listed"
    },
    "movement": {
      "transfer": "Transfer",
      "adjust": "Adjustment",
      "stepOf": "Step {{n}} / {{count}} · {{step}}",
      "steps": {
        "item": "Item",
        "source": "Source location",
        "sourceAdjust": "Location",
        "qty": "Quantity",
        "target": "Target location",
        "reason": "Reason",
        "note": "Photo and note",
        "confirm": "Confirm"
      },
      "cancelTransfer": "Cancel this transfer?",
      "cancelAdjust": "Cancel this adjustment?",
      "cancelBody": "What you entered will be discarded.",
      "cancelConfirm": "Cancel it",
      "scanned": "scanned",
      "picked": "selected",
      "qtyLabelTransfer": "Quantity to transfer",
      "qtyLabelAdjust": "Adjustment quantity",
      "remaining": "Left at the location",
      "remainingAdjust": "New location quantity",
      "continueTo": "Continue · {{step}}",
      "clear": "Clear",
      "deleteKey": "Delete",
      "decimalKey": "Decimal comma",
      "over": "The location holds {{available}} — no more can be moved.",
      "negativeAhead": "Stock will go negative.",
      "availableChanged": "The quantity at the location changed: {{available}}.",
      "directionOut": "Decrease",
      "directionIn": "Increase",
      "scanItem": "Scan an item or lot",
      "scanLocation": "Scan a location",
      "recent": "Recently used",
      "otherLocations": "Other locations",
      "noStock": "This item has no stock.",
      "noStockBody": "A movement can be entered once stock arrives through a receipt or a count.",
      "sameLocation": "Source and target cannot be the same location.",
      "fbaHint": "Sending to FBA warehouses goes through FBA shipment.",
      "defaultOnly": "No shelves defined yet — the movement is written to the warehouse's default location.",
      "noLocations": "No warehouse or location defined",
      "noLocationsBody": "They are set up on the web under Settings › Warehouses.",
      "lotRequired": "This item is lot-tracked — pick a lot.",
      "lotBlocked": "Stock cannot leave a blocked or quarantined lot.",
      "reasonNotAllowed": "This reason is not available for your role — pick another one.",
      "locationInactive": "This location is inactive.",
      "insufficient": "Not enough stock at the source location (now {{available}}).",
      "notePlaceholder": "Enter a description…",
      "noteRequired": "This reason needs a note",
      "photoRequired": "This reason needs a photo",
      "addPhoto": "Add a photo",
      "noReasons": "No manual reason for this kind.",
      "preview": "Result preview",
      "totalUnchanged": "Total on hand unchanged",
      "total": "Total on hand",
      "valueImpact": "Value impact",
      "reasonLine": "Reason: {{reason}}",
      "noteLine": "Note: {{note}}",
      "saveTransfer": "Save transfer",
      "saveAdjust": "Save adjustment",
      "savedTransfer": "Transfer saved · {{no}}",
      "savedAdjust": "Adjustment saved · {{no}}",
      "replayed": "This movement was already saved · {{no}}",
      "queuedTransfer": "Offline — the transfer is queued",
      "queuedAdjust": "Offline — the adjustment is queued",
      "queueFailed": "The movement could not be stored on this device (storage may be full). Keep this screen open and save again when the connection is back.",
      "undone": "Undone",
      "undoFailed": "Could not be undone — a reversing movement is needed.",
      "photoLeftBehind": "The movement was saved but the photo could not be uploaded.",
      "offlineNote": "A movement saved offline is re-checked on the server when the connection returns."
    },
    "comingSoon": "Comes with phase {{phase}}",
    "notifGroups": {
      "today": "Today",
      "yesterday": "Yesterday",
      "week": "This week",
      "older": "Older"
    },
    "noNotifications": "No notifications. Upcoming invoice due dates and approval requests appear here.",
    "markAllRead": "Mark all as read",
    "markRead": "Mark as read",
    "offline": "Offline — entries are queued",
    "sending": "Sending queue",
    "queueStuck": "Some entries could not be sent",
    "queueTitle": "Pending changes",
    "queueCount": "{{count}} entries",
    "queueNote": "Forms keep working. When the connection returns the queue is sent in order; if someone else changed the same record, the conflict list opens.",
    "queueBlocked": "Automatic retries have stopped. Fix it on the web and tap “Send now”, or remove the entry.",
    "queueEmpty": "Nothing pending.",
    "sendNow": "Send now",
    "discard": "Remove from queue",
    "discardConfirm": "This entry will be removed without being sent. Are you sure?",
    "lastError": "Last error: {{message}}",
    "magicHomeScreen": "Link sign-in does not work in the home-screen app: the e-mail link opens in Safari and never comes back here. Sign in with your password; if you have none, set one with “Forgot password” in the web app.",
    "signInLinkFailed": "The sign-in link could not be completed here. A link only works once, within 15 minutes, in the browser that requested it. Request a new link or sign in with your password.",
    "companyUnavailable": {
      "title": "Company details could not be loaded",
      "body": "There is no connection or the server cannot be reached. They load by themselves once you are back online."
    },
    "languageNames": {
      "tr": "Türkçe",
      "en": "English"
    },
    "pushLater": "Push notifications arrive in a later phase",
    "switchCompany": "Choose company",
    "expenseFx": "{{currency}} account — the TCMB/manual rate for the entry date is used",
    "photoAttached": "photo attached",
    "photoMissing": "The receipt photo is no longer on this device. Discard the entry and enter it again.",
    "removePhoto": "Remove photo",
    "noCategory": "No expense categories are shown on mobile. On the web, mark some as “Mobile” under Settings → Income / expense categories.",
    "today": {
      "tryAccounts": "TRY accounts",
      "overdueCount": "{{count}} overdue",
      "moreOverdue": "{{count}} more alerts — see them all on the web",
      "remaining": "{{amount}} left",
      "daysLate": "{{count}} d",
      "laterTiles": "Stock, production and Amazon tiles arrive with their modules (phases 2–6)."
    },
    "count": {
      "title": "Count",
      "blind": "blind count",
      "openMode": "open count",
      "progress": "{{counted}} / {{total}} counted",
      "location": "Location",
      "locationsTitle": "Locations",
      "locationCount": "{{count}} locations",
      "locationWord": "locations",
      "lineWord": "lines",
      "diffWord": "differ",
      "diffLines": "Lines with a difference",
      "diffCount": "{{count}} lines",
      "noDiff": "no difference",
      "finishCta": "Finish this location",
      "submitCta": "Submit count",
      "qtyLabel": "Counted quantity",
      "save": "Save",
      "saveNext": "Save · next",
      "saveClose": "Save · done",
      "clearCount": "Clear count",
      "expected": "expected {{qty}}",
      "chipMoved": "stock moved",
      "chipRecount": "recount",
      "chipUnexpected": "not on the list",
      "status": {
        "pending": "Not counted",
        "counting": "In progress · {{counted}}/{{total}}",
        "done": "Done",
        "doneDiffs": "Done · {{count}} differ",
        "recount": "Recount"
      },
      "scanItem": "Scan item or lot",
      "scanLocation": "Scan location label",
      "whichLot": "Which lot?",
      "uncountedTitle": "{{count}} lines not counted",
      "uncountedBody": "Mark the uncounted lines as not found (0)?",
      "uncountedBack": "Go back and count",
      "uncountedZero": "Mark as 0",
      "finished": "{{code}} done · {{lines}} lines, {{diffs}} differ",
      "reopened": "{{code}} reopened",
      "submitted": "{{no}} sent for approval",
      "submitQueued": "Offline — the count will be sent for approval when the connection returns",
      "withdrawn": "{{no}} withdrawn",
      "undoFinish": "{{code}} done",
      "undoSubmit": "{{no}} sent for approval",
      "pendingApproval": "Waiting for approval",
      "pendingApprovalBody": "Your partner will review the differences on the desktop.",
      "recountTitle": "Recount requested",
      "movedTitle": "Stock moved at this location during the count",
      "movedBody": "{{count}} lines affected",
      "otherCounter": "{{name}} is counting this location — the same lines may be counted twice.",
      "otherCounterAnon": "Another device is counting this location — the same lines may be counted twice.",
      "lineOverwritten": "{{code}} · {{name}}: another device counted this line and the server kept its quantity. Check the shelf together.",
      "clearIgnored": "{{code}} · {{name}}: the clear did not reach the server in time and the quantity stands. Enter the right one.",
      "emptyLocation": "Nothing is expected at this location",
      "emptyLocationBody": "Scan what you find to add it.",
      "notOnDevice": "This count is not on this device",
      "notOnDeviceBody": "You can open it when the connection returns.",
      "noRightsBody": "Counting needs the operator, partner or owner role.",
      "storageFailed": "The record could not be written to this device — storage may be full.",
      "elsewhereTitle": "This item is at {{code}}.",
      "elsewhereGo": "Go to {{code}}",
      "locationOutside": "{{code}} is not part of this count",
      "unexpectedTitle": "Unexpected item",
      "unexpectedBody": "{{name}} is not on this location’s list. You can add it to the count and enter a quantity.",
      "unexpectedLotRequired": "{{name}} is lot-tracked — scan the lot label first.",
      "unexpectedAdd": "Add to the count",
      "startTitle": "Start a count",
      "startCta": "Start the count",
      "startOffline": "Starting a count needs a connection. A count that has begun can be continued offline.",
      "startFailed": "The count could not be started.",
      "startReplay": "{{no}} had already been started.",
      "warehouse": "Warehouse",
      "locations": "Locations",
      "scopeAll": "All locations ({{count}})",
      "scopePick": "Pick locations",
      "zoneAll": "select {{count}} locations",
      "zoneClear": "clear selection",
      "zoneDefault": "Default",
      "mode": "Count type",
      "modeBlind": "Blind count",
      "modeOpen": "Open count",
      "modeBlindHint": "Expected quantities stay hidden until a line is counted.",
      "modeOpenHint": "Expected quantities are shown on the lines.",
      "assignee": "Counter",
      "assigneeMe": "Me",
      "resumeTitle": "Count in progress",
      "resumeCta": "Continue",
      "queueKind": "Count",
      "queueSubmitKind": "Count submission",
      "queueSubmitTail": "goes for approval",
      "closed": {
        "approved": "Approved — the differences were posted to stock.",
        "cancelled": "The count was cancelled.",
        "reverted": "The count was reverted."
      },
      "a11yLot": "lot {{lot}}",
      "a11yUncounted": "not counted",
      "a11yCounted": "counted {{qty}} {{unit}}",
      "a11yDiff": "difference {{diff}} ({{pct}}%)",
      "a11yHint": "Tap to enter a quantity"
    },
    "conflicts": {
      "title": "Conflicts",
      "lede": "Someone changed the same stock while you were offline. Choose what happens to each line.",
      "empty": "No conflicts left",
      "needsOnline": "Resolving a conflict needs a connection.",
      "moved": "{{qty}} {{unit}} moved during the count",
      "recount": "Recount",
      "keep": "Send as counted",
      "kept": "The count will be sent as it stands.",
      "insufficient": "{{code}} now holds {{qty}}",
      "sendAvailable": "Send {{qty}} instead"
    },
    "queueEntries": "{{count}} records in this row",
    "queueWaiting": "Waiting for an earlier record",
    "queueConflictRow": "Conflict — tap to resolve",
    "queueConflicts": "{{count}} records conflicted",
    "queueConflictsCta": "Open the conflict list ({{count}})",
    "queueResolve": "Resolve the conflict",
    "discardCount": "The {{count}} counted lines of this location will be deleted from this device.",
    "accounting": {
      "title": "Pre-accounting",
      "lede": "Contacts, invoices, cash and partners — the same figures as the web",
      "sections": "Sections",
      "cashOnHand": "Cash & bank",
      "receivable": "Receivable",
      "payable": "Payable",
      "contactCount": "{{count}} contacts",
      "accountCount": "{{count}} accounts",
      "openInvoices": "{{count}} open invoices",
      "readOnly": "Invoices, contact records, settings and period close are handled on the web.",
      "openOnWeb": "Open on the web",
      "contacts": {
        "empty": "No contacts yet",
        "emptyBody": "Contacts are added on the web, in Accounting › Contacts.",
        "noResults": "No results for “{{query}}”",
        "noResultsFilter": "No contacts under this filter",
        "noResultsBody": "Search by name, tax no, e-mail, phone or city.",
        "noOpenItems": "No open items"
      },
      "cash": {
        "noAccountsBody": "The first cash or bank account is opened on the web.",
        "closedSection": "Closed accounts",
        "loadMore": "Load more",
        "contactSearch": "Search by contact name…",
        "contactMore": "{{count}} more contacts — narrow with search",
        "dateHint": "DD.MM.YYYY",
        "dateInvalid": "Write the date as DD.MM.YYYY",
        "noCategories": "No category of this kind yet; categories are created in the web settings.",
        "offlineWrite": "Correcting and deleting need a connection; neither is queued.",
        "transferDeleteOut": "A transfer is deleted from the ledger of the account the money leaves.",
        "fxDiffManual": "An FX difference has no field to correct: to change the amount or the direction, delete the record and enter it again.",
        "documentAdd": "Add a document",
        "documentReplace": "Replace the document",
        "documentReplaceNote": "The new document takes the old one's place; the old file stays in the archive.",
        "documentOffline": "Opening the document needs a connection.",
        "documentLinkCopied": "Document link copied — valid for {{minutes}} minutes.",
        "documentFailed": "Could not open the document"
      },
      "invoices": {
        "subtitle": "{{count}} invoices · {{open}} open",
        "empty": "No invoices of this type",
        "emptyBody": "Invoices are created on the web; they land here as soon as they are entered.",
        "paidSplit": "{{paid}} paid · {{remaining}} left",
        "collectedSplit": "{{paid}} collected · {{remaining}} left",
        "qtyAtPrice": "{{qty}} × {{price}}",
        "lineDiscount": "{{pct}}% discount",
        "noPayments": "No payment matched yet"
      },
      "partners": {
        "lede": "Who put in what, and who owes whom",
        "baseNote": "Fair share, difference and settlement are computed on the TRY equivalent; foreign lines are converted at the transaction rate.",
        "empty": "No partners yet",
        "emptyBody": "Partner expenses and capital movements appear here once they are recorded on the web.",
        "accounts": "Partner accounts",
        "costSetupWeb": "Reference rates are entered in the web settings."
      },
      "period": {
        "webOnly": "The 12-week cash-flow projection and the accountant export stay on the web."
      }
    },
    "documents": {
      "moreNote": "Upload, open, share or save to the device",
      "count": "{{count}} documents",
      "searchPlaceholder": "Search by name, file name or note",
      "all": "All",
      "actions": "Actions",
      "details": "Details",
      "noResults": "No results for “{{query}}”",
      "noResultsFilter": "No documents in this folder",
      "noResultsBody": "Search by document name, file name or note.",
      "pickFailed": "Could not pick the file",
      "tooBig": "This file is {{size}} — {{mb}} MB is the limit.",
      "badType": "This file type cannot be uploaded: .{{ext}}",
      "unknownType": "The file type could not be determined — pick a file with an extension.",
      "uploadTitle": "Upload document",
      "uploadFolder": "Into which folder?",
      "uploading": "Uploading — a large file may take a while, stay in the app.",
      "foldersOnWeb": "New folders are created on the web, in Documents.",
      "offlineWrite": "Uploading and changing documents needs a connection; neither is queued.",
      "readOnly": "Your role cannot upload or change documents.",
      "notFound": "This document is no longer in the list",
      "notFoundBody": "It may have been archived, or removed by someone else.",
      "openFailed": "Could not open the document",
      "shareFailed": "Could not open the share sheet",
      "saveFailed": "Could not download the document",
      "saveHint": "Use “Save to Files” in the share sheet to keep it on the phone.",
      "savedWeb": "Downloading the document",
      "linkCopied": "Link copied — valid for {{minutes}} minutes",
      "linkShared": "A link was shared, not the file — anyone opening it sees the document for {{minutes}} minutes.",
      "shareWebNote": "In a browser a link valid for {{minutes}} minutes is shared instead of the file.",
      "imageFailed": "This image could not be shown in the app",
      "imageFailedBody": "The phone's own viewer can probably open this type.",
      "openOutside": "Open on the device",
      "zoomHint": "Pinch with two fingers to zoom",
      "closeViewer": "Close the image",
      "edit": "Edit",
      "editTitle": "Edit document",
      "titleLabel": "Document name",
      "validUntilLabel": "Valid until",
      "validUntilHint": "DD.MM.YYYY",
      "validUntilInvalid": "Write the date as DD.MM.YYYY",
      "saved": "Document updated"
    }
  },
  "validation": {
    "required": "This field is required",
    "email": "Enter a valid e-mail",
    "number": "Enter a valid number (e.g. 1,234.56)",
    "positive": "Enter a value greater than zero",
    "date": "Enter a valid date",
    "currency": "Choose a currency",
    "taxNo": "Tax no must be 10 digits, ID no 11 digits",
    "iban": "Invalid IBAN",
    "passwordLength": "The password must be at least 12 characters",
    "category": "Choose a category",
    "contact": "Choose a contact",
    "targetAccount": "Choose the target account",
    "sameAccount": "Source and target account cannot be the same",
    "colourHex": "Colour must be written as #RRGGBB",
    "integer": "Enter a whole number greater than zero",
    "percent": "Enter a percentage between 0 and 100",
    "code": "Use only A–Z, 0–9 and hyphens in the code",
    "codeTaken": "This code is already in use",
    "unitCode": "Use only lower-case letters, digits and underscores",
    "sku": "A SKU starts with a letter or digit and may contain letters, digits, dots, underscores and hyphens",
    "skuTaken": "This SKU already exists",
    "gtin": "Invalid barcode (EAN-8, UPC-12, EAN-13 or GTIN-14)",
    "barcodeTaken": "This barcode belongs to another item",
    "qtyNotIntegral": "The quantity does not come out whole in the base unit ({{unit}})",
    "unitUnknown": "This unit is not defined for the item",
    "hours": "Daily capacity must be between 0 and 24 hours",
    "rangeOrder": "The end cannot be lower than the start",
    "rangeTooLarge": "At most {{count}} locations at a time",
    "hsCode": "HS code must look like 4803 or 4803.00.90"
  },
  "glyphs": {
    "title": "Turkish glyph test",
    "sample": "Çağrı Işıkoğlu said: “İğneyi önce kendine batır.” — ç ğ ı İ ö ş ü · Ç Ğ I İ Ö Ş Ü",
    "mono": "SAS-2026-0091 · ÜE-2026-0418 · PEC-26-0871 · 1,234.56 TRY"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications. They appear here when your partner records money movement or an invoice falls due.",
    "markAllRead": "Mark all as read",
    "unread": "{{count}} unread"
  },
  "stock": {
    "matrix": {
      "crumb": "On-hand matrix",
      "title": "On hand",
      "subtitle": "{{items}} items · {{locations}} locations",
      "addMovement": "Add movement",
      "view": "Saved view: {{name}}",
      "views": {
        "all": "All",
        "critical": "Critical watch",
        "save": "Save this view…"
      },
      "size": "Size: {{value}}",
      "colour": "Colour: {{value}}",
      "all": "all",
      "selected": "{{count}} selected",
      "legend": "Days-of-cover colour scale:",
      "legendLater": "Days of cover: arrives with phase 6",
      "legendSr": "Days of cover, dark to light: 10 days and under, 11–20 days, 21–30 days, 31–45 days, 46–70 days, more than 70 days.",
      "col": {
        "item": "Item",
        "unit": "Unit",
        "total": "Total",
        "cover": "Cover",
        "coverTitle": "Days of cover (forecast)"
      },
      "coverLater": "Days of cover is computed from the sales forecast — it arrives with Planning (phase 6).",
      "coverAria": "Days of cover {{days}} days, forecast",
      "coverAriaNone": "Days of cover cannot be computed — the forecast arrives with phase 6",
      "columns": "Columns",
      "columnsTitle": "Columns",
      "columnsLocked": "The Item and Total columns are always visible.",
      "lots": "LOTS · {{name}}",
      "showLots": "Show lots",
      "hideLots": "Hide lots",
      "lotCol": {
        "lot": "Lot",
        "location": "Location",
        "note": "Source",
        "date": "Date",
        "qty": "Quantity"
      },
      "noLotTracking": "no lot tracking",
      "noStock": "This item has no stock.",
      "lotsError": "The lots could not be loaded.",
      "footerValue": "Total stock value",
      "footerFiltered": "Filtered stock value",
      "empty": "No stock yet. Start by importing the opening stock.",
      "importOpening": "Import opening stock",
      "emptyFiltered": "No item matches these filters.",
      "clearFilters": "Clear the filters",
      "error": "The stock could not be loaded",
      "movedBy": "{{name}} posted a movement for this item",
      "exportName": "aslen-ops-on-hand",
      "csv": {
        "status": "Status",
        "cover": "Days of cover",
        "value": "Stock value ({{currency}})"
      }
    },
    "panel": {
      "tabs": {
        "general": "General",
        "stock": "Stock",
        "cost": "Cost",
        "movements": "Movements"
      },
      "totalOnHand": "Total on hand",
      "inBase": "= {{qty}}",
      "cover": "Days of cover",
      "days": "days",
      "coverLater": "arrives with phase 6",
      "distribution": "Location breakdown",
      "valueByColumn": "Stock value by zone",
      "distributionEmpty": "This item has no stock.",
      "specs": "Specification",
      "spec": {
        "sizeFold": "Size / fold",
        "gsm": "Grammage",
        "packaging": "Packaging",
        "bobbinYield": "Bobbin yield",
        "reorderPoint": "Reorder point",
        "standardCost": "Standard cost",
        "amazon": "Amazon listings",
        "amazonLater": "Amazon listings arrive with phase 4",
        "width": "Width",
        "bobbinWeight": "Bobbin weight",
        "leadTime": "Lead time",
        "measure": "Dimensions",
        "sku": "SKU",
        "type": "Type",
        "barcode": "Barcode",
        "baseUnit": "Base unit",
        "stockUnit": "Stock unit",
        "lotTracked": "Lot tracking",
        "shelfLife": "Shelf life",
        "lastMove": "Last movement",
        "avgCost": "Average cost",
        "stockValue": "Stock value"
      },
      "on": "on",
      "off": "off",
      "unlimited": "unlimited",
      "dayCount": "{{count}} days",
      "gsmValue": "{{gsm}} g/m² · {{weight}} g per piece",
      "packagingValue": "{{pack}} pcs per pack · {{packs}} packs per case = {{pieces}} pcs",
      "bobbinYieldValue": "1 bobbin {{kg}} kg ≈ {{cases}} {{unit}}",
      "perUnit": "{{value}} / {{unit}}",
      "costNote": "Values are computed with the average cost at the time of each movement.",
      "onlyMovements": "Stock only changes through a <b>movement</b>. There is no editable quantity field here.",
      "itemCard": "Item card",
      "editInItemCard": "Edit on the item card →",
      "noMovements": "No movement for this item yet.",
      "allInLedger": "See them all in the ledger →"
    },
    "masked": "hidden",
    "maskedTitle": "Cost and sales price hidden · operator role",
    "offline": {
      "title": "No connection",
      "body": "The stock shown is as of {{time}}. The web app has no offline queue — it refreshes once the connection is back.",
      "cannotSave": "No connection — a movement cannot be saved."
    },
    "type": {
      "raw_material": "Raw material",
      "semi_finished": "Semi-finished",
      "finished_good": "Finished good",
      "packaging": "Packaging",
      "consumable": "Consumable"
    },
    "form": {
      "title": "New stock movement",
      "draft": "{{no}} · draft",
      "kind": "Movement type",
      "item": "Item",
      "itemPlaceholder": "Search an item — name, SKU or barcode",
      "itemEmpty": "No matching item.",
      "onHandOption": "{{qty}} on hand",
      "lot": "Lot / batch",
      "lotPlaceholder": "Pick a lot",
      "lotEmpty": "This item has no lot.",
      "newLot": "+ New lot · {{no}}",
      "newLotPlain": "+ New lot",
      "newLotLabel": "new lot",
      "noLotTracking": "No lot tracking",
      "qty": "Quantity",
      "signMinus": "Decrease",
      "signPlus": "Increase",
      "from": "Source location",
      "to": "Target location",
      "location": "Location",
      "locationPlaceholder": "Pick a location",
      "locationEmpty": "No matching location.",
      "reason": "Reason",
      "noManualReason": "No manual reason for this type.",
      "note": "Note",
      "notePlaceholder": "Short note — e.g. preparing shipment FBA-US-2026-0035",
      "photo": "Photo",
      "removePhoto": "Remove photo",
      "photoLimit": "At most {{count}} photos.",
      "photoTooBig": "A photo may not exceed 10 MB.",
      "photoUploadFailed": "The movement was saved but {{count}} photos could not be uploaded.",
      "unitCost": "Unit cost",
      "unitCostBase": "= {{value}} / {{unit}}",
      "lotSection": "New lot details",
      "supplier": "Supplier",
      "supplierLotNo": "Supplier lot no",
      "expiry": "Expiry",
      "preview": "Result preview",
      "previewEmpty": "Pick item, lot, quantity and location to see the result here.",
      "previewLine": "{{location}} · {{lot}}",
      "totalUnchanged": "Total on hand unchanged",
      "total": "Total on hand",
      "valueImpact": "Value impact",
      "negativeBlocked": "Stock would go negative — warehouse {{warehouse}} does not allow it.",
      "negativeAllowed": "Stock will go negative — warehouse {{warehouse}} allows it.",
      "sourceChanged": "Source balance changed: {{before}} → {{after}} {{unit}}",
      "save": "Save movement",
      "saveError": "Movement could not be saved",
      "networkError": "No connection — the movement was not saved. The web app has no offline queue; try again once you are back online.",
      "noLocations": "Define a warehouse and locations first.",
      "noLocationsLink": "Settings › Warehouses",
      "dirtyTitle": "Changes not saved",
      "dirtyBody": "What you entered will be discarded.",
      "dirtyConfirm": "Close",
      "readOnlyNotice": "Read only — this role cannot make changes",
      "errors": {
        "item": "Pick an item",
        "lot": "Pick a lot",
        "from": "Pick a source location",
        "to": "Pick a target location",
        "location": "Pick a location",
        "reason": "Pick a reason",
        "sameLocation": "Source and target cannot be the same",
        "noteRequired": "This reason needs a note",
        "noteLong": "A note may be 500 characters at most",
        "photoRequired": "This reason needs a photo",
        "insufficient": "Not enough stock at the source — at most {{max}} {{unit}}"
      },
      "unitCostHintStandard": "Left empty, the item's standard cost is used; failing that the last inbound cost, and failing both 0 ₺.",
      "unitCostHintAverage": "Left empty, the item's current moving average is used.",
      "unitCostNoBasis": "This item has neither a standard nor an average cost — left empty, the movement is booked at 0 ₺ and only a reversal can correct it."
    },
    "ledger": {
      "crumb": "Movement ledger",
      "title": "Movement ledger",
      "subtitle": "Stock only changes through movements · {{from}}–{{to}} / {{total}} records",
      "subtitleEmpty": "Stock only changes through movements",
      "new": "New movement",
      "exportName": "aslen-ops-movement-ledger",
      "exportLimit": "The first {{count}} records were exported.",
      "preset": {
        "today": "Today",
        "yesterday": "Yesterday",
        "7d": "Last 7 days",
        "month": "This month",
        "all": "All time",
        "custom": "Custom range…"
      },
      "customFrom": "From",
      "customTo": "To",
      "filter": {
        "kind": "Type: {{value}}",
        "warehouse": "Warehouse: {{value}}",
        "person": "Person: {{value}}",
        "reason": "Reason: {{value}}"
      },
      "showReversed": "Show undone movements",
      "clearFilters": "Clear filters",
      "col": {
        "date": "Date",
        "kind": "Type",
        "item": "Item",
        "lot": "Lot",
        "qty": "Quantity",
        "route": "Source → Target",
        "reason": "Reason",
        "who": "Person"
      },
      "csv": {
        "no": "No",
        "sku": "SKU",
        "unit": "Unit",
        "from": "Source",
        "to": "Target",
        "note": "Note"
      },
      "reversed": "Undone",
      "isReversal": "Reversal",
      "emptyToday": "No movement today yet.",
      "emptyWarehouse": "No movement in this warehouse yet.",
      "emptyFiltered": "No movement matches these filters.",
      "error": "Movements could not be loaded",
      "moreError": "More records could not be loaded.",
      "loadMore": "Load more",
      "detail": {
        "subtitle": "{{date}} · {{actor}}",
        "item": "Item",
        "lot": "Lot / batch",
        "qty": "Quantity",
        "route": "Source → Target",
        "reason": "Reason",
        "note": "Note",
        "photos": "Photos",
        "cost": "Unit cost",
        "value": "Value",
        "source": "Entered on",
        "sources": {
          "web": "web",
          "mobile": "mobile",
          "import": "import",
          "system": "system",
          "sync": "sync"
        },
        "reversedBy": "Reversing movement",
        "reversalOf": "Reversal of",
        "openItem": "Item card",
        "photoError": "The photo could not be opened."
      }
    },
    "route": {
      "receipt": "Goods receipt",
      "production": "Production",
      "scrap": "Scrap",
      "sale": "Sale",
      "sample": "Sample",
      "return": "Return",
      "opening": "Opening",
      "count": "Count",
      "adjustment": "Adjustment",
      "issue": "Issue"
    },
    "toast": {
      "in": "Receipt saved · {{qty}} → {{to}}",
      "out": "Issue saved · {{qty}} · {{from}}",
      "transfer": "Transfer saved · {{qty}} → {{to}}",
      "adjust": "Adjustment saved · {{qty}} · {{location}}",
      "undone": "Movement undone · {{no}}",
      "reversed": "Reversal saved · {{no}}",
      "replay": "This movement had already been saved · {{no}}"
    },
    "reverse": {
      "action": "Create a reversal",
      "confirmTitle": "Reversal",
      "confirmBody": "{{no}} will be reversed: {{qty}}, {{location}}.",
      "confirm": "Save the reversal",
      "note": "Note",
      "notePlaceholder": "Why is it being reversed?",
      "noteRequired": "A reversal needs a note"
    },
    "status": {
      "normal": "normal",
      "low": "low",
      "critical": "critical",
      "negative": "negative"
    },
    "movementKinds": {
      "in": "Receipt",
      "out": "Issue",
      "transfer": "Transfer",
      "adjust": "Adjustment"
    },
    "reasons": {
      "opening": "Opening stock",
      "count": "Count variance"
    },
    "onHand": "On hand",
    "onHandNone": "no stock",
    "lot": "Lot",
    "lots": {
      "crumb": "Lots",
      "title": "Lots",
      "subtitle": "{{count}} lots · {{inStock}} in stock",
      "subtitleEmpty": "No lots yet",
      "search": "Search a lot number…",
      "filter": {
        "all": "All",
        "inStock": "In stock",
        "depleted": "Depleted",
        "quarantine": "Quarantine",
        "series": "Type: {{value}}",
        "supplier": "Supplier: {{value}}"
      },
      "col": {
        "lot": "Lot",
        "item": "Item",
        "type": "Type",
        "location": "Location",
        "onHand": "On hand",
        "received": "In",
        "source": "Source",
        "quality": "Quality",
        "expiry": "Expiry",
        "unitCost": "Unit cost",
        "lastMove": "Last movement"
      },
      "origin": {
        "receipt": "Goods receipt",
        "production": "Production",
        "opening": "Opening stock",
        "adjustment": "Manual entry",
        "return": "Return"
      },
      "qc": {
        "none": "No record",
        "pending": "Pending",
        "accepted": "Accepted",
        "passed": "Passed",
        "failed": "Failed",
        "quarantine": "Quarantine"
      },
      "expired": "Expired",
      "blocked": "Quarantine",
      "moreLocations": "+{{count}}",
      "open": "Open the lot genealogy",
      "empty": "No lots yet. Lots are created by a goods receipt, by production, or by the opening-stock import.",
      "importOpening": "Import opening stock",
      "emptyFiltered": "No lot matches these filters.",
      "clearFilters": "Clear filters",
      "exportName": "aslen-lots"
    },
    "counts": {
      "crumb": "Counts",
      "title": "Counts",
      "subtitle": "{{open}} open · {{pending}} awaiting approval · updated {{time}}",
      "subtitleEmpty": "No counts yet",
      "new": "New count",
      "exportName": "counts",
      "wholeWarehouse": "whole warehouse",
      "empty": "No counts yet. Start one here and count it on the phone.",
      "emptyFiltered": "No count matches these filters.",
      "clearFilters": "Clear filters",
      "offlineStart": "Offline — a count cannot be started.",
      "filter": {
        "all": "All",
        "open": "Open",
        "pending": "Awaiting approval",
        "approved": "Approved"
      },
      "col": {
        "no": "Count no",
        "scope": "Warehouse · location",
        "status": "Status",
        "counter": "Counted by",
        "lines": "Lines",
        "variance": "Differ",
        "value": "Value impact",
        "date": "Date"
      },
      "status": {
        "draft": "Draft",
        "in_progress": "Counting",
        "submitted": "Awaiting approval",
        "recount_requested": "Recount",
        "approved": "Approved",
        "cancelled": "Cancelled",
        "reverted": "Reverted"
      },
      "kind": {
        "cycle": "cycle",
        "full": "full count",
        "opening": "opening"
      },
      "line": {
        "equal": "equal",
        "over": "difference",
        "within": "small difference",
        "uncounted": "not counted",
        "conflict": "conflict",
        "conflictTitle": "Stock moved on this line during the count; the expected quantity was recalculated.",
        "recount": "recount",
        "adjusted": "adjusted",
        "ignored": "ignored",
        "unexpected": "unexpected"
      },
      "start": {
        "title": "Start a count",
        "subtitle": "Counting happens on the phone; the web opens and assigns the session.",
        "warehouse": "Warehouse",
        "warehousePlaceholder": "Pick a warehouse",
        "warehouseRequired": "Pick a warehouse.",
        "locations": "Locations",
        "locationsHint": "{{count}} locations can be counted in this warehouse.",
        "locationsRequired": "Pick at least one location.",
        "selectAll": "Select all",
        "clearAll": "Clear selection",
        "remove": "Remove {{code}}",
        "zone": "{{zone}} · {{count}} locations",
        "searchLocations": "Search locations…",
        "noMatch": "No location matches this search.",
        "pickWarehouseFirst": "Pick a warehouse first.",
        "noLocations": "This warehouse has no active location. Add one in Settings › Warehouses / locations.",
        "defaultLocation": "General",
        "assignee": "Counted by",
        "assigneeHint": "Left empty, whoever opens the session on the phone takes it.",
        "assigneeNone": "Unassigned",
        "blind": "Blind count",
        "blindNote": "the counter does not see the expected quantities",
        "note": "Note",
        "submit": "Start the count",
        "started": "{{countNo}} started · {{name}} notified",
        "startedUnassigned": "{{countNo}} started",
        "replay": "{{countNo}} had already been started",
        "mobileNote": "Counts are entered on the phone only. The session shows up in the mobile Count screen; you approve it here."
      },
      "review": {
        "title": "Count review",
        "subtitle": "Approving creates one adjustment movement per difference",
        "backToList": "Back to counts",
        "notFound": "This count was not found.",
        "noLines": "This count has no lines.",
        "exportName": "count-{{countNo}}",
        "selectAll": "Select every line with a difference",
        "selectLine": "Select the line {{name}}",
        "col": {
          "item": "Item · lot",
          "location": "Location",
          "expected": "Expected",
          "counted": "Counted",
          "variance": "Difference",
          "value": "Value impact"
        },
        "tile": {
          "counted": "Lines counted",
          "countedUnit": "/ {{count}} expected",
          "variance": "Lines differing",
          "varianceUnit": "lines",
          "net": "Net quantity difference",
          "value": "Value impact"
        },
        "caseEquivalent": "case equivalent",
        "mixedUnit": "mixed units",
        "netExcluded": "{{count}} lines without a case unit are not included",
        "recount": "Request a recount",
        "approve": "Approve the differences",
        "pickRows": "Pick the lines to approve",
        "offlineBody": "Approving and requesting a recount need a connection.",
        "selfApproval": "Your partner approves your own count",
        "selfApprovalOwner": "To approve your own count, turn on “Self-approval” in Settings › Stock and counting.",
        "mobileOnly": "Counts are entered on the phone — the web starts, reviews and approves them.",
        "conflictTitle": "Stock moved on {{count}} lines during the count",
        "conflictBody": "The expected quantity of those lines was recalculated as of the count. Check them and approve.",
        "footerSelected": "{{selected}} lines selected · {{counted}} lines counted",
        "footerNet": "net {{value}}",
        "banner": {
          "submitted": "{{counter}} count is awaiting your approval",
          "submittedNoName": "The count is awaiting approval",
          "counted": "{{counted}} lines counted, {{over}} with a difference",
          "countedClean": "{{counted}} lines counted, no difference",
          "running": "The count is running",
          "progress": "{{counted}} / {{expected}} lines counted",
          "recount": "A recount was requested",
          "recountBody": "{{count}} lines will be recounted by {{name}}",
          "approved": "The count is approved",
          "approvedBy": "{{name}} approved it",
          "movements": "{{count}} adjustment movements",
          "seeMovements": "See the movements",
          "cancelled": "The count was cancelled",
          "reverted": "The count was reverted"
        }
      },
      "approve": {
        "title": "Approve the count differences",
        "lead": "This cannot be undone. Approving creates the",
        "leadCount": "{{count}} adjustment movements",
        "leadTail": "below and changes stock permanently.",
        "stale": "The count changed in the meantime — the numbers were refreshed.",
        "staleRefused": "The count changed in the meantime — the numbers were refreshed",
        "staleSame": "The count changed in the meantime — the numbers shown are the same",
        "staleCheck": "Check the numbers and approve again.",
        "changedLines": "{{count}} lines were counted again",
        "droppedLines": "{{count}} lines left the selection",
        "appearedLines": "{{count}} new differences appeared, not selected",
        "nothingLeft": "No line is left to approve — go back to the count list and look again.",
        "noLot": "adjustment",
        "total": "Total value impact",
        "unselected": "{{count}} lines with a difference are not selected; their stock will not change.",
        "uncounted": "{{count}} uncounted lines will be ignored.",
        "reason": "The reason “Count difference” will be set and linked to this session",
        "cta": "Create {{count}} movements",
        "done": "{{count}} adjustment movements created"
      },
      "close": {
        "title": "Close the count",
        "body": "{{count}} lines were counted and nothing differs. Closing it leaves stock unchanged and marks the session approved.",
        "cta": "Close the count"
      },
      "recount": {
        "title": "Request a recount",
        "body": "The {{count}} selected lines will be recounted by {{name}}. Stock does not change until the count is approved.",
        "bodyUnassigned": "The {{count}} selected lines will be recounted. Stock does not change until the count is approved.",
        "note": "Note",
        "notePlaceholder": "e.g. check behind shelf D1-B-04 as well",
        "cta": "Request a recount",
        "done": "Recount requested · {{count}} lines"
      }
    },
    "location": "Location",
    "locations": "Locations",
    "warehouse": "Warehouse",
    "zone": "Zone",
    "qty": "Quantity",
    "unit": "Unit",
    "baseUnit": "Base unit",
    "stockUnit": "Stock unit",
    "movesOnlyByMovement": "Stock only changes through a movement.",
    "fbaFromAmazon": "FBA stock arrives with the Amazon connection.",
    "locationTypes": {
      "storage": "Storage",
      "receiving": "Receiving",
      "shipping": "Shipping",
      "production": "Production line",
      "quarantine": "Quarantine",
      "scrap": "Scrap",
      "transit": "In transit"
    },
    "warehouseTypes": {
      "own": "Own warehouse",
      "fba": "FBA warehouse",
      "supplier": "Supplier warehouse",
      "transit": "In transit",
      "third_party": "Third-party warehouse"
    },
    "trace": {
      "title": "Lot genealogy",
      "subtitleFull": "Full chain from the bobbin lot to the FBA shipment · {{count}} tiers",
      "subtitleChain": "{{from}} → {{to}} · full chain · {{count}} tiers",
      "subtitleSingle": "This lot is not linked to another record yet · 1 tier",
      "forward": "Trace forward",
      "backward": "Trace backward",
      "graphLabel": "Lot genealogy",
      "tierAria": "Tier {{n}} · {{label}}",
      "tier": {
        "source": "Source",
        "lot": "Lot",
        "output": "Output",
        "bobbin": "Bobbin lot",
        "napkin": "Napkin lot",
        "productionOrder": "Production order",
        "fbaShipment": "FBA shipment",
        "sale": "Sale",
        "waste": "Waste",
        "sample": "Sample"
      },
      "badge": {
        "origin": "source",
        "scrap": "waste",
        "sale": "sold",
        "fba_inbound": "in transit",
        "sample": "sample",
        "production_consume": "production",
        "production_order": "running"
      },
      "nodeAria": "{{tier}} {{code}}, {{qty}}, {{status}}",
      "placeholder": "This lot has not been used in production, a shipment or a sale yet.",
      "legendSelected": "Selected node",
      "legendInChain": "In the chain",
      "massBalance": "Total mass balance:",
      "massBalanceValue": "{{in}} kg in → {{out}} kg output + {{waste}} kg waste",
      "massBalanceGap": "{{gap}} kg unexplained",
      "massBalanceRunning": "production running",
      "truncated": "Chain shortened — {{count}} nodes are not shown.",
      "panelLabel": "Selected node details",
      "qty": "Quantity",
      "unitCost": "Unit cost",
      "onHandNote": "On hand: {{qty}}",
      "costBreakdown": "Cost breakdown",
      "costEmpty": "The cost has not been calculated yet.",
      "qcTitle": "Quality control",
      "qcEmpty": "No quality record for this lot.",
      "specs": "Details",
      "spec": {
        "supplier": "Supplier",
        "supplierLot": "Supplier lot no",
        "purchaseOrder": "Purchase order",
        "receipt": "Goods receipt",
        "productionOrder": "Production order",
        "producedAt": "Produced on",
        "location": "Location",
        "container": "Container",
        "expiry": "Expiry",
        "origin": "Source",
        "note": "Note",
        "initial": "Initial quantity"
      },
      "movementsTitle": "Movements",
      "movements": "See movements",
      "printLabel": "Print a label",
      "printLabelLater": "The label screen arrives later in Phase 2.",
      "labelOnlyLots": "Labels are printed for lots only.",
      "notFound": "This lot was not found. It may have been deleted or renumbered.",
      "backToLots": "Back to lots",
      "exportName": "aslen-lot-genealogy",
      "exported": "Genealogy exported",
      "csv": {
        "tier": "Tier",
        "kind": "Type",
        "code": "Number",
        "item": "Item",
        "target": "Location / target",
        "from": "From",
        "to": "To"
      },
      "status": {
        "accepted": "Accepted",
        "passed": "Passed",
        "pending": "Pending",
        "failed": "Failed",
        "quarantine": "Quarantine",
        "inStock": "In stock",
        "depleted": "Depleted",
        "negative": "Negative",
        "inChain": "In the chain"
      },
      "cost": {
        "fob_unit": "FOB unit price",
        "landed_addon": "Landed add-on",
        "landed_unit": "Landed unit ($)",
        "fx": "FX rate ({{date}})",
        "landed_unit_base": "Landed unit (₺)",
        "opening_unit": "Opening unit cost",
        "material": "Material",
        "packaging": "Packaging",
        "labour": "Labour + machine",
        "overhead": "Overhead",
        "total": "Actual total"
      }
    },
    "lotEdit": {
      "edit": "Edit the lot",
      "title": "Edit lot details",
      "subtitle": "{{lot}} · the quantity only changes with a movement",
      "expiry": "Expiry date",
      "expiryHint": "Left empty, no shelf life is tracked.",
      "supplierLot": "Supplier lot number",
      "supplierLotHint": "The batch number the supplier shipped it under.",
      "qtyNote": "The lot quantity does not change here — a quantity only changes with a stock movement.",
      "expiryInvalid": "Pick a valid date.",
      "expiryBeforeReceipt": "The expiry date cannot be before the goods receipt.",
      "nothingToSave": "Nothing changed.",
      "saved": "{{lot}} updated",
      "block": "Put in quarantine",
      "unblock": "Release from quarantine",
      "blockTitle": "Put the lot in quarantine?",
      "blockBody": "While {{lot}} is in quarantine no issue movement can use it. The {{qty}} on hand stays in stock but cannot be used.",
      "unblockTitle": "Release the lot from quarantine?",
      "unblockBody": "{{lot}} becomes usable again — the {{qty}} on hand is opened to issue movements.",
      "blocked": "{{lot}} put in quarantine",
      "unblocked": "{{lot}} released from quarantine",
      "onlyApprover": "Only you and your partner can decide on quarantine."
    }
  },
  "items": {
    "title": "Items",
    "searchPlaceholder": "Search item, SKU, ASIN…",
    "countLine": "{{count}} items · {{filter}}",
    "allTypes": "all types",
    "attrFilterCount": "{{count}} attribute filters",
    "import": "Import",
    "columns": "Columns",
    "new": "New item",
    "masked": "hidden",
    "types": {
      "all": "All",
      "raw_material": "raw material",
      "semi_finished": "semi-finished",
      "finished_good": "finished good",
      "packaging": "packaging",
      "consumable": "consumable",
      "service": "service"
    },
    "typesTitle": {
      "raw_material": "Raw material",
      "semi_finished": "Semi-finished",
      "finished_good": "Finished good",
      "packaging": "Packaging",
      "consumable": "Consumable",
      "service": "Service"
    },
    "status": {
      "draft": "draft",
      "active": "active",
      "inactive": "inactive"
    },
    "stockStatus": {
      "low": "Low",
      "critical": "Critical",
      "negative": "Negative"
    },
    "attrs": {
      "size": "Size",
      "fold": "Fold",
      "format": "Format",
      "colour": "Colour",
      "print": "Print",
      "printDesign": "Print design",
      "gsm": "Grammage",
      "unitWeight": "Napkin weight",
      "rollWidth": "Width",
      "dims": "Dimensions",
      "widthMm": "Width",
      "material": "Material",
      "cert": "Certification",
      "hs": "HS code",
      "origin": "Origin"
    },
    "folds": {
      "1/4": "1/4 fold",
      "1/6": "1/6 fold",
      "1/8": "1/8 fold",
      "pocket": "Pocket",
      "flat": "Flat"
    },
    "formats": {
      "dinner": "Dinner",
      "cocktail": "Cocktail",
      "guest_towel": "Guest towel"
    },
    "prints": {
      "none": "none",
      "foil": "Foil",
      "digital": "Digital",
      "foil_digital": "Foil + digital"
    },
    "colours": {
      "beyaz": "White",
      "fildisi": "Ivory",
      "bej": "Beige",
      "gri": "Grey",
      "altin": "Gold",
      "lacivert": "Navy",
      "siyah": "Black",
      "terracotta": "Terracotta",
      "kahve": "Brown",
      "bebek_mavisi": "Baby blue"
    },
    "filters": {
      "add": "+ {{key}}",
      "clear": "Clear filters",
      "active": "{{key}}: {{value}}",
      "remove": "Remove the {{key}} filter"
    },
    "views": {
      "heading": "Saved views",
      "all": "All items",
      "critical": "Critical watch",
      "on_amazon": "Sold on Amazon",
      "unmapped": "Unmapped",
      "inactive": "Inactive items",
      "groups": "Item groups"
    },
    "cols": {
      "product": "Item",
      "type": "Type",
      "sizeFold": "Size · fold",
      "colour": "Colour",
      "onHand": "On hand",
      "stdCost": "Std. cost",
      "amazon": "Amazon",
      "status": "Status"
    },
    "chooser": {
      "title": "Columns",
      "reset": "Reset",
      "name": "Item name",
      "sku": "SKU",
      "type": "Type",
      "sizeFold": "Size · fold",
      "colour": "Colour",
      "onHand": "On hand",
      "stdCost": "Standard cost",
      "marketplaces": "Amazon marketplaces",
      "cover": "Days of cover",
      "reorderPoint": "Reorder point",
      "lastMove": "Last movement"
    },
    "bulk": {
      "selected": "items selected",
      "labels": "Print labels",
      "assignAttr": "Assign attribute",
      "addToView": "Add to saved view",
      "export": "Export",
      "deactivate": "Deactivate",
      "clear": "Clear selection",
      "hiddenByFilter": "{{count}} outside the filter",
      "selectAll": "Select the visible items",
      "labelsPending": "The label screen opens in a later round of this phase"
    },
    "empty": {
      "title": "No items yet",
      "body": "Add your first item, or import a batch with the template.",
      "noResult": "No item matches ‘{{q}}’.",
      "noResultAction": "Clear search",
      "noFilterResult": "No item matches these filters.",
      "groups": "No item groups yet. Define a group to keep variants together.",
      "boms": "This item has no product tree. Create a draft to define its components and operations.",
      "uoms": "This item only has its base unit.",
      "whereUsed": "This item is not used in any product tree.",
      "critical": "No item is critical — all of them are above their reorder point.",
      "unmapped": "Every active finished good is mapped to at least one Amazon listing."
    },
    "confirm": {
      "deactivateTitle": "Deactivate these items?",
      "deactivateBody": "{{count}} items will become inactive and leave the lists and pickers. Past movements and costs stay as they are.",
      "deactivate": "Deactivate",
      "deleteDraftTitle": "Delete the draft?",
      "deleteDraftBody": "Draft v{{version}} and its components will be deleted. The active version is untouched.",
      "deleteDraft": "Delete draft",
      "activateTitle": "Activate v{{version}}?",
      "activateBody": "The new version takes effect immediately and the previous one is archived. The standard cost is recalculated from this tree.",
      "activate": "Activate",
      "deleteGroupTitle": "Delete the group?",
      "deleteGroupBody": "Group ‘{{name}}’ will be deleted. Its items stay, without a group.",
      "deactivateSkipped": "{{count}} item(s) are components of an active product tree; the server may skip them: {{skus}}"
    },
    "toast": {
      "saved": "Item saved",
      "statusChanged": "{{count}} items updated",
      "statusPartial": "{{ok}} items updated, {{failed}} could not be",
      "attributesAssigned": "Attribute assigned to {{count}} items",
      "barcodeSaved": "Barcode saved",
      "groupSaved": "Group saved",
      "bomSaved": "Product tree saved",
      "bomActivated": "v{{version}} activated",
      "bomCopied": "Product tree copied — opened as a draft",
      "bomDraftDeleted": "Draft deleted",
      "costRecomputed": "Standard cost recalculated",
      "created": "Item created — {{sku}}"
    },
    "form": {
      "newTitle": "New item",
      "editTitle": "Edit item",
      "copyTitle": "Copy item",
      "sections": {
        "general": "Identity",
        "attributes": "Attributes",
        "units": "Units and packaging",
        "planning": "Planning",
        "customs": "Customs",
        "cost": "Cost"
      },
      "sku": "SKU",
      "skuHint": "Upper-case letters, digits, dots, underscores and hyphens. Try not to change it once the item has moved.",
      "skuSuggest": "Suggest from attributes",
      "nameTr": "Name",
      "nameEn": "Name (English)",
      "shortName": "Short name",
      "shortNameHint": "Used on labels and in mobile lists.",
      "type": "Type",
      "group": "Item group",
      "groupNone": "No group",
      "status": "Status",
      "baseUnit": "Base unit",
      "baseUnitHint": "Stock is stored in this unit and cannot be changed later.",
      "stockUnit": "Stock unit",
      "stockUnitHint": "On-hand figures are shown in this unit.",
      "barcode": "Barcode",
      "uomPreset": "Unit preset",
      "uomPresetNapkin": "Napkin (pcs · pack · case · kg)",
      "uomPresetBobbin": "Bobbin (kg · bobbin · pallet)",
      "uomPresetNone": "Define manually",
      "uomUnit": "Unit",
      "uomFactor": "Factor to base unit",
      "uomBarcode": "Barcode",
      "uomPurchaseDefault": "Purchase default",
      "uomSalesDefault": "Sales default",
      "uomOrderMultiple": "Order multiple",
      "uomCountable": "Usable when counting",
      "addUom": "+ Add unit",
      "lotTracked": "Lot tracked",
      "lotTrackedHint": "When off, movements are written without a lot.",
      "lotSeries": "Lot series",
      "shelfLife": "Shelf life (days)",
      "reorderPoint": "Reorder point",
      "reorderQty": "Reorder quantity",
      "safetyStockDays": "Safety stock (days)",
      "leadTimeDays": "Lead time (days)",
      "minBatchQty": "Minimum batch",
      "defaultSupplier": "Default supplier",
      "hsCode": "HS code",
      "countryOfOrigin": "Country of origin",
      "notes": "Note",
      "standardCost": "Standard cost",
      "standardCostHint": "For bought items enter the supplier's currency; the ₺ value is computed from the rate.",
      "standardCostComputed": "{{value}} at rate {{rate}}",
      "weightFormulaHint": "formula: {{value}}",
      "sizeWidth": "Width (cm)",
      "sizeHeight": "Height (cm)",
      "uomPresetNapkinShort": "Napkin",
      "uomPresetBobbinShort": "Bobbin",
      "certHint": "Separate several with · or a comma.",
      "costFromBom": "The standard cost is rolled up from the product tree, not typed here.",
      "standardCostRate": "Rate (₺)",
      "unsavedTitle": "Changes not saved",
      "unsavedBody": "If you leave now, what you typed is lost.",
      "unsavedLeave": "Leave",
      "packQty": "Pieces per pack",
      "casePacks": "Packs per case",
      "palletCases": "Cases per pallet",
      "packagingHint": "Prefilled from settings; change it if this item is packed differently.",
      "copySourceHint": "Copying from {{sku}} — give it a new SKU.",
      "costMasked": "Only the partners can see the cost fields."
    },
    "groups": {
      "title": "Item groups",
      "new": "Add group",
      "edit": "Edit group",
      "name": "Name",
      "description": "Description",
      "variantKeys": "Variant attributes",
      "variantKeysHint": "Items in a group differ only in these attributes — the colour swap when copying a product tree follows them.",
      "lotSeries": "Lot series",
      "itemCount": "{{count}} items"
    },
    "detail": {
      "tabs": {
        "general": "General",
        "stock": "Stock",
        "bom": "Product tree",
        "cost": "Cost",
        "amazon": "Amazon mappings",
        "suppliers": "Suppliers",
        "movements": "Movements",
        "documents": "Documents",
        "pricing": "Sale price"
      },
      "photo": "item\nphoto",
      "stats": {
        "onHand": "On hand",
        "stdCost": "Std. cost",
        "marketplaces": "Marketplace",
        "reorderPoint": "Reorder point"
      },
      "general": {
        "attributes": "Attributes",
        "planning": "Planning and packaging",
        "salesPack": "Sales pack",
        "case": "Case",
        "caseDims": "Case dimensions",
        "pallet": "Pallet",
        "reorderPoint": "Reorder point",
        "safetyStock": "Safety stock",
        "batch": "Production batch",
        "leadTime": "Production time",
        "shelfLife": "Shelf life",
        "unlimited": "unlimited",
        "lotTracked": "lot tracked",
        "lotNotTracked": "no lot tracking",
        "days": "{{count}} days",
        "minQty": "min. {{qty}}"
      },
      "stock": {
        "byLocation": "On hand by location",
        "total": "Total",
        "lots": "Lots",
        "lot": "Lot",
        "location": "Location",
        "source": "Source",
        "qty": "Quantity",
        "onlyMovements": "Stock only changes through a <b>movement</b> — nothing on this tab is editable.",
        "emptyLocations": "No stock yet. Locations appear here after the first movement.",
        "emptyLots": "No lot on hand.",
        "notLotTracked": "This item is not lot tracked."
      },
      "bom": {
        "title": "Product tree",
        "forQty": "{{date}} · for {{qty}}",
        "addComponent": "+ Add component",
        "addOperation": "+ Add operation",
        "component": "Component",
        "qtyPer": "Quantity",
        "scrap": "scrap {{pct}}",
        "scrapPct": "Scrap %",
        "optional": "Optional",
        "ops": "Operations",
        "opSeq": "#",
        "opName": "Operation",
        "opWorkCenter": "Work centre",
        "opMinutes": "min/1000",
        "opScrap": "Scrap %",
        "totalTime": "Total time",
        "totalTimeValue": "{{min}} min per 1000 pcs",
        "history": "Version history",
        "newVersion": "New version",
        "copyFrom": "Copy from another item",
        "swapVariants": "Switch components to this item's colour",
        "changeNote": "Change note",
        "costTitle": "Material cost for {{qty}}",
        "costSub": "With the quantities of this version",
        "scrapMismatch": "The component scrap differs from the sum of the operation scraps.",
        "status": {
          "draft": "draft",
          "active": "active",
          "archived": "archived"
        },
        "event": {
          "draft": "v{{v}} draft created",
          "active": "v{{v}} activated",
          "archived": "v{{v}} archived"
        },
        "version": "Version",
        "linesEmpty": "This version has no components.",
        "opsEmpty": "No operation — labour and machine count as zero in the cost.",
        "grossHint": "{{qty}} including scrap",
        "missingCost": "{{count}} component(s) have no standard cost",
        "readOnlyNote": "The product tree is read-only in this round; the draft editor comes next.",
        "serviceEmpty": "Service items have no product tree.",
        "whereUsed": "Used in product trees",
        "qtyPerBase": "Qty / base batch"
      },
      "cost": {
        "standard": "Standard cost",
        "actual": "Actual cost (last order)",
        "average": "Average cost",
        "breakdownActual": "Breakdown — actual cost",
        "breakdownStandard": "Breakdown — standard cost",
        "trend": "Standard cost trend",
        "trendSub": "Last 12 months · {{unit}}",
        "change12": "Change over 12 months",
        "recompute": "Recalculate",
        "driftWarning": "The cost computed from the product tree differs from the stored standard cost by {{pct}}%.",
        "cats": {
          "material": "Material — {{what}}",
          "packaging": "Packaging — {{what}}",
          "labour": "Labour",
          "machine": "Machine",
          "consumable": "Foil / ink",
          "overhead": "Overhead {{pct}}%",
          "materialShort": "Material",
          "packagingShort": "Packaging",
          "overheadMissing": "Overhead (rate not entered)"
        },
        "standardBomNote": "v{{v}} product tree · {{date}}",
        "standardManualNote": "entered manually · {{date}}",
        "standardEmpty": "No standard cost yet.",
        "actualPending": "Calculated once the first production order is completed.",
        "averageNote": "{{qty}} {{unit}} on hand · weighted average",
        "averageEmpty": "No stock on hand.",
        "breakdownEmpty": "The breakdown needs a calculated standard cost.",
        "trendEmpty": "The trend needs at least two months of data.",
        "driftTitle": "The product tree gives a different standard cost",
        "driftBody": "From the tree: {{computed}} · stored: {{stored}} ({{pct}})."
      },
      "pricing": {
        "noMigrationTitle": "Channel settings are not in the database yet",
        "noMigrationBody": "The calculation is running on the built-in Trendyol defaults: the answer is correct but cannot be saved. Once migration 20261104000001 is applied, the commission, shipping and target margin are stored as a listing.",
        "noCostTitle": "This item's unit cost is unknown",
        "noCostBody": "Without a cost the price only covers the commission. Enter a standard cost on the Cost tab, or receive the purchase invoice to create a real one.",
        "channel": "Marketplace",
        "packQty": "Listing pack",
        "packQtyHint": "Units sold in one listing",
        "mode": "Direction",
        "modePrice": "Solve for price",
        "modeMargin": "Check a price I have",
        "targetMargin": "Target margin",
        "listPrice": "List price",
        "savedListing": "Saved listing",
        "createListing": "Save as listing",
        "saved": "Listing saved",
        "saveNeedsMigration": "Saving needs the migration to be applied.",
        "unreachableTitle": "No price reaches this margin",
        "unreachableBody": "Commission and advertising already take {{pct}} of the sale; with the target margin that passes 100%. Lower the margin, or the commission and ad spend.",
        "awaitingPriceTitle": "Enter the price to check",
        "awaitingPriceBody": "Type the list price and the margin, break-even and payout are worked out from it. The table below works by pack size with or without a price.",
        "requiredPrice": "Price to list at",
        "requiredPriceNote": "VAT included · {{per}}/{{unit}}",
        "afterDiscount": "Price to list · the buyer pays {{paid}} after {{pct}}",
        "corporateTax": "Corporate tax",
        "netProfit": "Net profit after tax",
        "margin": "Contribution margin",
        "marginNote": "{{profit}} contribution · {{markup}} on cost",
        "breakEven": "Break-even price",
        "breakEvenNote": "Below this the sale loses money",
        "payout": "Marketplace payout",
        "payoutNote": "after {{days}} days · commission, shipping and withholding deducted",
        "stack": "Cost stack",
        "stackSub": "VAT excluded · per listing",
        "stackEmpty": "No costs entered.",
        "netRevenue": "Revenue (VAT excluded)",
        "totalCost": "Total cost",
        "profit": "Contribution",
        "scales": "scales with price",
        "packUnits": "× {{n}} boxes",
        "desiBadge": "{{desi}} desi",
        "ladderPackWarn": "Packaging is held flat on every row — how many units one box holds has not been entered. Enter it and the bigger packs are costed with their real box count.",
        "ladderShipWarn": "Shipping is held flat on every row, but desi grows with the pack: 100 units ≈ 880 g, 600 units ≈ 5.3 kg. Real shipping on the bigger packs is higher — until the desi tariff is entered, the ladder leans in their favour.",
        "notional": "notional",
        "cash": "Cash and tax",
        "grossPrice": "What the customer pays",
        "vatOut": "Output VAT",
        "vatIn": "Deductible VAT",
        "vatPayable": "VAT this sale owes",
        "vatCarry": "feeds the VAT carry-over",
        "withholding": "E-commerce withholding",
        "withholdingNote": "not a cost — offset against corporate tax",
        "cashAfterVat": "Left after the VAT is paid",
        "cashFoot": "The 1% withholding (Presidential Decree 9284) is taken on the VAT-excluded sale price and offset against the annual corporate tax, which is why it is not in the cost stack. While the margin stays thin, the part that cannot be offset becomes a refund claim.",
        "params": "Parameters",
        "paramsSub": "Anything marked \"Assumed\" has to be confirmed in the seller panel",
        "assumed": "Assumed",
        "ladder": "How the pack size moves the price",
        "ladderSub": "Shipping and the service fee are per parcel; the bigger the pack, the smaller their share per unit",
        "ladderFoot": "Every row is solved again at the same target margin — comparing pack sizes at one fixed price is not a question anybody asks. This table solves for the price even when the direction is set to \"{{mode}}\".",
        "costSource": {
          "average": "Unit cost {{cost}}/{{unit}} — moving average, from actual purchases",
          "standard": "Unit cost {{cost}}/{{unit}} — standard cost. The reference figure from the Elhadefler proforma is not Aslen's own cost (E25); it becomes an average once the purchase invoice is received."
        },
        "lines": {
          "goods": "Goods",
          "packaging": "Packaging (box, bag, label)",
          "labour": "Pack labour",
          "other": "Other (e-invoice, integrator)",
          "overhead": "Overhead share",
          "commission": "Marketplace commission",
          "serviceFee": "Service fee",
          "shipping": "Shipping",
          "ads": "Advertising",
          "returns": "Return burden",
          "finance": "Cost of the payout term"
        },
        "p": {
          "commission": "Commission",
          "shipping": "Shipping",
          "desi": "Desi",
          "desiHint": "This pack's desi; it scales with the pack size",
          "desiUnit": "desi",
          "shippingFromTariff": "{{desi}} desi · read from the carrier tariff",
          "serviceFee": "Service fee",
          "vat": "Product VAT rate",
          "packaging": "Packaging",
          "packagingUnit": "Units per box",
          "packagingUnitHint": "Left empty, packaging is treated as flat at every pack size",
          "packagingUnitUsed": "This listing uses {{n}} boxes (a box cannot be split, so this rounds up)",
          "packagingUnitEmpty": "not measured",
          "labour": "Labour",
          "other": "Other",
          "overhead": "Overhead share",
          "overheadHint": "Rent, office, accountant ÷ normal capacity · labour is separate · not part of inventory valuation (IAS 2.16)",
          "inventoryDays": "Days in stock",
          "inventoryDaysHint": "Cost of money runs over {{total}} days (stock + payout term)",
          "campaign": "Campaign discount",
          "campaignHint": "Expected discount; the list price rises so the sale still hits the target",
          "ads": "Advertising (share of revenue)",
          "returnPct": "Return rate",
          "returnScrap": "Scrapped on return",
          "payoutDays": "Payout term",
          "capital": "Annual cost of money",
          "withholding": "Withholding",
          "rounding": "Price rounding",
          "days": "days",
          "netHint": "VAT excluded, per listing",
          "otherHint": "VAT excluded · credits, subscription share",
          "returnScrapHint": "Share of returns that cannot be sold again; its VAT is lost too (VAT Act 30/c)",
          "capitalHint": "read from capital_cost_rates · notional",
          "shippingVatIncl": "Shipping amount includes VAT",
          "shippingVatInclNote": "Trendyol deducts it VAT-inclusive from the payout"
        },
        "rounding": {
          "none": "No rounding",
          "integer": "To whole lira",
          "x90": "End in .90",
          "x99": "End in .99"
        },
        "ladderCols": {
          "qty": "Units",
          "price": "List price",
          "perUnit": "Per {{unit}}",
          "desi": "Desi",
          "shipShare": "Shipping share",
          "packShare": "Packaging share",
          "profit": "Contribution",
          "breakEven": "Break-even"
        }
      },
      "amazon": {
        "title": "Amazon mappings",
        "add": "Add mapping",
        "market": "Marketplace",
        "sellerSku": "Seller SKU",
        "asin": "ASIN",
        "packQty": "Pieces per pack",
        "price": "Price",
        "fbaStock": "FBA stock",
        "status": {
          "matched": "matched",
          "sync_error": "sync error",
          "manual": "manual",
          "inactive": "inactive"
        },
        "unconfirmed": "Pieces per pack will be confirmed once the SKU list is final — unit economics derives from this number.",
        "phaseBody": "Listings, prices and FBA stock arrive with the Amazon connection."
      },
      "suppliers": {
        "title": "Suppliers",
        "supplier": "Supplier",
        "code": "Item code",
        "leadTime": "Lead time",
        "minOrder": "Min. order",
        "lastPrice": "Last price",
        "phaseBody": "Supplier rows and last prices arrive with the purchasing module."
      },
      "movements": {
        "title": "Movements",
        "date": "Date",
        "kind": "Kind",
        "route": "From → To",
        "lot": "Lot",
        "qty": "Quantity",
        "empty": "No movement yet. The ledger fills up after the first one."
      },
      "documents": {
        "title": "Documents",
        "document": "Document",
        "kind": "Kind",
        "uploader": "Uploaded by",
        "date": "Date",
        "kinds": {
          "specification": "Specification",
          "quality": "Quality",
          "design": "Design",
          "label": "Label",
          "certificate": "Certificate",
          "delivery_note": "Delivery note",
          "photo": "Photo",
          "other": "Other"
        },
        "upload": "Upload document",
        "uploaded": "Document uploaded",
        "empty": "No document yet. Add the specification, a test report or the label template here.",
        "kindTitle": "Document kind"
      },
      "backToList": "Back to items",
      "notFound": "Item not found. It may be deleted or belong to another company.",
      "moreActions": "More actions",
      "activate": "Activate",
      "inactiveTitle": "This item is inactive",
      "inactiveBody": "It cannot be picked in purchasing, production or product trees. Past records stay as they are.",
      "draftTitle": "Draft item",
      "draftBody": "A draft item cannot be used on sales documents or Amazon listings."
    },
    "phaseSoon": "Opens in {{phase}}",
    "maskedAria": "Cost hidden — your role cannot see this field",
    "assign": {
      "subtitle": "{{count}} item(s) selected",
      "attribute": "Attribute",
      "value": "Value",
      "clear": "Clear the value",
      "preview": "Will change: {{count}} item(s)",
      "previewChange": "{{count}} item(s) get a new value",
      "previewFill": "{{count}} item(s) get it for the first time",
      "apply": "Apply to {{count}} item(s)"
    }
  },
  "imports": {
    "breadcrumb": "Import / export",
    "templateDownload": "Download template",
    "template": {
      "xlsx": "Download XLSX template",
      "csv": "Download CSV template"
    },
    "phaseLockedTitle": "This import comes later",
    "phaseLockedBody": "Contact and opening-balance imports arrive in a later phase.",
    "kinds": {
      "items": "Items",
      "opening_stock": "Opening stock",
      "contacts": "Contacts",
      "opening_balances": "Opening balances"
    },
    "title": {
      "items": "Item import",
      "opening_stock": "Opening stock import",
      "contacts": "Contact import",
      "opening_balances": "Opening balance import"
    },
    "subtitle": {
      "items": "SKU, name, type, unit conversions and standard cost · existing SKUs are skipped",
      "opening_stock": "On-hand quantities per warehouse, location and lot · every row is posted as an “Opening stock” movement",
      "contacts": "Customer and supplier records",
      "opening_balances": "Opening amounts for contacts, cash and bank accounts"
    },
    "steps": {
      "file": "File uploaded",
      "mapping": "Columns mapped",
      "preview": "Rows validated",
      "result": "Records written"
    },
    "stepNotes": {
      "done": "done",
      "active": "running",
      "pending": "waiting",
      "waiting": "needs approval"
    },
    "drop": {
      "title": "Drop the file here",
      "active": "Drop — the file will be read",
      "hint": "{{kind}} template · XLSX or CSV · up to {{rows}} rows · {{size}} MB",
      "choose": "Choose file",
      "reading": "Reading… {{done}} rows",
      "readingAria": "Reading the file"
    },
    "file": {
      "meta": "{{rows}} rows · {{size}} · {{when}}",
      "detected": "Detected type",
      "template": "{{kind}} template · v1",
      "mapping": "Not the template — map the columns",
      "unreadable": "Unreadable",
      "unreadableTitle": "The file could not be read"
    },
    "preflight": {
      "title": "Before you start",
      "open": "Open",
      "items": "Items defined",
      "itemsDetail": "{{count}} items",
      "itemsDetailLots": "{{count}} items · {{lots}} of them lot-tracked",
      "warehouses": "Warehouses and locations defined",
      "warehousesDetail": "{{warehouses}} warehouses · {{locations}} locations",
      "unitConversions": "Unit conversions",
      "unitConversionsDetail": "{{count}} items have no conversion for their stock unit",
      "unitsDetail": "{{count}} active units",
      "unitsMissing": "No unit of measure defined yet.",
      "standardCosts": "Standard costs",
      "standardCostsDetail": "{{count}} items have no standard cost — give a unit cost in the file",
      "standardCostsOk": "Every item has a standard cost",
      "opening": "Opening stock still open",
      "openingLocked": "Opening stock is locked — correct it with a count.",
      "openingOpen": "Not locked yet",
      "note": {
        "items": "Existing SKUs are skipped; new items are created with the status the file states.",
        "opening_stock": "Quantity is the total on hand for that item, location and lot on the opening date. If stock already exists, only the difference is posted — uploading the same file twice does not double the stock.",
        "contacts": "",
        "opening_balances": ""
      }
    },
    "history": {
      "title": "Upload history",
      "empty": "No imports yet. Download the template, fill it in and upload it.",
      "rows": "{{count}} rows",
      "rowsShort": "Rows",
      "file": "File",
      "discarded": "Import discarded"
    },
    "mapping": {
      "title": "Column mapping",
      "count": "{{count}} columns · first 5 rows sampled",
      "decimal": "Decimal",
      "decimalComma": "Comma (1.234,5)",
      "decimalDot": "Dot (1,234.5)",
      "decimalShort": {
        "comma": "comma",
        "dot": "dot"
      },
      "dateFormat": "Date",
      "dateFormats": {
        "dmy": "DD.MM.YYYY",
        "ymd": "YYYY-MM-DD",
        "dmySlash": "DD/MM/YYYY"
      },
      "fileColumn": "Column in the file",
      "field": "Field",
      "samples": "Sample values",
      "unnamed": "(unnamed column)",
      "ignore": "Ignore",
      "fieldFor": "Field for “{{column}}”",
      "status": {
        "mapped": "mapped",
        "ignored": "will be ignored"
      },
      "missing": "Required column missing: {{columns}}",
      "ok": "{{count}} required columns mapped · date format {{date}} · decimal separator {{decimal}}",
      "ignoredCount": "{{count}} columns will be ignored",
      "previewTitle": "Preview of the first rows",
      "previewCount": "first {{shown}} of {{total}} rows"
    },
    "preview": {
      "openingDate": "Opening date",
      "openingDateHint": "Written as the movement date",
      "openingDateFuture": "The opening date cannot be in the future.",
      "skipErrors": "Skip the {{count}} failing rows and post the rest",
      "readAt": "Current stock read at {{time}}",
      "revalidate": "Validate again",
      "staleTitle": "Rows were validated again",
      "staleBody": "The current stock of {{count}} rows changed after validation. Check them and post again.",
      "kpiOk": "Valid rows",
      "kpiOkUnit": "/ {{total}}",
      "kpiWarning": "With warnings",
      "kpiError": "Failing",
      "kpiLots": "New lots",
      "kpiLotsNote": "Lots named in the file that do not exist yet",
      "kpiValue": "Total value",
      "rowsUnit": "rows",
      "lotsUnit": "lots",
      "unpriced": "{{count}} rows carry no cost in the file",
      "filters": {
        "all": "All",
        "ok": "Valid",
        "warning": "Warning",
        "error": "Error",
        "unchanged": "Unchanged"
      },
      "searchPlaceholder": "Search SKU, lot, location…",
      "downloadErrors": "Download failing rows",
      "changeFile": "Change file",
      "cols": {
        "row": "Row",
        "item": "Item",
        "location": "Warehouse · location",
        "variance": "Current → change",
        "value": "Value"
      },
      "noRows": "No rows in this filter.",
      "subtotal": "Total · {{count}} rows will be posted",
      "lotNew": "new",
      "lotExisting": "existing",
      "lotAuto": "auto",
      "lotAutoNote": "The lot cell is empty — a number will be generated.",
      "noChange": "no change",
      "baseQtyHint": "Quantity converted to the base unit",
      "costFromFile": "{{cost}}/{{unit}} · file",
      "costFromStandard": "{{cost}}/{{unit}} · standard",
      "costMissing": "no cost",
      "costStandard": "standard cost will be used"
    },
    "rowStatus": {
      "preview": {
        "ok": "valid",
        "warning": "warning",
        "error": "error",
        "unchanged": "no change",
        "skipped": "will skip"
      },
      "posted": {
        "ok": "posted",
        "warning": "posted",
        "error": "skipped",
        "unchanged": "unchanged",
        "skipped": "skipped"
      }
    },
    "batchStatus": {
      "uploaded": "running",
      "validating": "running",
      "validated": "validated",
      "posting": "running",
      "posted": "posted",
      "partial": "partly posted",
      "failed": "failed",
      "reverted": "reverted",
      "discarded": "discarded"
    },
    "confirm": {
      "title": "Post the opening stock",
      "body": "Confirming creates {{count}} opening movements and changes stock for good. You can undo it within {{seconds}} seconds; after that it takes a reversal.",
      "cta": "Create {{count}} movements",
      "groupMeta": "{{rows}} rows · {{lots}} new lots",
      "total": "Total value impact",
      "reason": "The reason will be “Opening stock”, linked to the count session dated {{date}}",
      "decreases": "{{count}} rows are below the stock already there — an opening quantity cannot be lowered, so those rows are not posted; correct them with a count.",
      "withoutCost": "{{count}} rows carry no cost in the file",
      "skipped": "{{count}} failing rows will be skipped",
      "unpriced": "{{count}} rows are not in the total — their cost comes from the item's standard cost."
    },
    "result": {
      "title": "Opening stock posted",
      "bodyStock": "{{movements}} movements written ({{first}} – {{last}}) · count sessions {{counts}} · {{lots}} new lots · {{value}} in total",
      "bodyItems": "{{created}} items created · {{updated}} items updated · {{skipped}} rows skipped",
      "revertedTitle": "Import reverted",
      "revertedBody": "{{count}} reversing movements were written. Stock is back to where it was.",
      "goStock": "Go to stock on hand",
      "goItems": "Go to items",
      "newImport": "New import",
      "rowsTitle": "Posted rows",
      "rowsUnread": "The posted rows could not be re-read — the list below still shows the dry run.",
      "cols": {
        "movement": "Movement no"
      },
      "goLedger": "Open the movement ledger",
      "printLabels": "Print labels for the new lots ({{count}})",
      "toast": "Opening stock posted — {{count}} movements"
    },
    "revert": {
      "cta": "Revert with a reversal",
      "title": "Revert the opening stock?",
      "bodyStock": "{{count}} reversing movements will be written and the value impact drops by {{value}}. Reverting is blocked if anything left those lots after the opening.",
      "bodyItems": "Items this import created and that never moved are deactivated. Updated items are not reverted; their previous values are in the audit log.",
      "confirm": "Revert",
      "blockedTitle": "Could not be reverted"
    },
    "cta": {
      "mapColumns": "Map the columns",
      "validate": "Validate",
      "validating": "Validating… {{done}} / {{total}}",
      "validatingShort": "Validating…",
      "post": "Post to stock",
      "done": "Done",
      "hasErrors": "{{count}} failing rows — fix or skip them.",
      "nothingToPost": "Nothing to post — every row matches the current stock."
    },
    "footer": {
      "templateComplete": "The template is complete — the mapping step is skipped",
      "needsMapping": "Not the template — map the columns",
      "mapping": "Check the mapping, then validate",
      "preview": "{{count}} rows will be posted · {{skipped}} skipped · {{lots}} new lots",
      "result": "{{count}} movements written · {{skipped}} rows skipped · {{unchanged}} rows unchanged"
    },
    "cancel": {
      "title": "Discard this import?",
      "body": "The validated rows are deleted and stock does not change. The file stays in the history as “discarded”.",
      "keep": "Keep going"
    },
    "states": {
      "offlineTitle": "No connection",
      "offlineBody": "The file can still be read, but validating and posting need a connection.",
      "failedTitle": "The operation could not be completed",
      "blockedTitle": "A precondition is missing",
      "blockedBody": "The file cannot be validated until the preconditions are met."
    },
    "errors": {
      "type": "This file type is not supported. Upload an XLSX, CSV or TSV.",
      "tooLarge": "The file is over the {{size}} MB limit.",
      "noRows": "The file has no data rows.",
      "tooManyRows": "The file has {{count}} rows; at most {{max}} can be uploaded. Split it per warehouse.",
      "unreadable": "The file looks encrypted or damaged. Open it in Excel and save it again.",
      "alreadyPosted": "This file was already posted on {{when}}. Posting it again writes only the differences.",
      "uploadFailed": "The archive copy of the file could not be uploaded — the import can still continue.",
      "sheetFallback": "The “{{sheet}}” sheet was not found — the first sheet was read.",
      "templateFailed": "The template file could not be built. Reload the page and try again."
    },
    "section": {
      "importTitle": "Import",
      "historyTitle": "Import history",
      "cards": {
        "items": "SKU, name, type, unit conversions, reorder point and standard cost. Existing SKUs are skipped.",
        "opening_stock": "Opening quantities per warehouse, location and lot. Every row is posted as a stock movement with the “Opening stock” reason; stock never changes directly.",
        "contacts": "Customer and supplier records: name, tax number, country, currency, terms and contact details.",
        "opening_balances": "Open receivable and payable balances of contacts plus the opening amounts of cash and bank accounts."
      },
      "lastImport": "Last import: {{when}} · {{rows}} rows",
      "never": "No imports yet",
      "partnersOnly": "Importing is open to partners only.",
      "openingLocked": "Opening stock is locked — corrections are made with a stock count.",
      "template": "Template",
      "start": "Import",
      "resume": "Open the pending import",
      "exportsLater": "Exports arrive in this section in the next round; the “Export” button on tables already gives CSV."
    },
    "codes": {
      "sku_required": "SKU required",
      "sku_format": "SKU format",
      "sku_duplicate": "Duplicate SKU",
      "name_required": "Name required",
      "type_required": "Type required",
      "type_unknown": "Unknown type",
      "base_unit_default": "Base unit assumed",
      "barcode_check_digit": "Barcode check digit",
      "already_exists": "Already exists",
      "lot_tracked_locked": "Lot tracking cannot be turned off",
      "item_unknown": "Item not found",
      "item_not_stocked": "Not stocked",
      "item_draft": "Draft item",
      "name_mismatch": "Different name",
      "warehouse_unknown": "Warehouse not found",
      "fba_forbidden": "FBA warehouse",
      "location_warehouse": "Location in another warehouse",
      "location_unknown": "Location not found",
      "row_duplicate": "Duplicate row",
      "qty_required": "Quantity required",
      "qty_positive": "Negative quantity",
      "qty_not_integral": "Quantity cannot be split",
      "unit_unknown": "Unit not defined",
      "unit_default": "Unit assumed",
      "lot_not_allowed": "Lot not allowed",
      "lot_item_mismatch": "Lot of another item",
      "lot_required": "Lot number required",
      "currency_unknown": "Unknown currency",
      "fx_missing": "Missing FX rate",
      "cost_missing": "No cost",
      "opening_decrease": "Opening cannot be lowered",
      "opening_locked": "Opening locked",
      "unchanged": "No change"
    }
  },
  "documents": {
    "title": "Documents",
    "empty": "No documents yet",
    "emptyBody": "Registry gazette, lease, permits, policies — the company's papers are uploaded here.",
    "noFolder": "Unfiled",
    "maxSize": "{{mb}} MB max",
    "upload": "Upload document",
    "uploaded": "Document uploaded",
    "open": "Open",
    "share": "Share",
    "download": "Download",
    "linkCopied": "Link copied",
    "archive": "Archive",
    "archiveTitle": "Archive document",
    "archiveBody": "The document leaves the list but the file is not erased: its record and audit trail stay.",
    "archived": "Document archived",
    "fields": {
      "name": "Document name",
      "fileName": "File",
      "titleHint": "Left empty, the file name is used.",
      "folder": "Folder",
      "fileType": "Type",
      "size": "Size",
      "uploader": "Uploaded by",
      "uploadedAt": "Uploaded",
      "validUntil": "Valid until",
      "validUntilHint": "For papers with a date to watch — leases, permits, policies.",
      "note": "Note"
    },
    "validity": {
      "none": "No expiry",
      "valid": "Until {{date}}",
      "soon": "{{date}} — {{days}} days left",
      "expired": "{{date}} — expired {{days}} days ago",
      "badgeExpired": "expired",
      "badgeSoon": "{{days}} days left",
      "expiredNote": "This document expired on {{date}} — you can upload a newer one.",
      "soonNote": "This document expires on {{date}}."
    },
    "cabinet": {
      "subtitle": "{{count}} documents · the company's own cabinet",
      "searchPlaceholder": "Search name, note…",
      "csvName": "documents",
      "dropHere": "Drop the files here",
      "emptyFolder": "No documents in this folder. Add one with “Upload document”.",
      "emptySearch": "No document matches the search."
    },
    "folders": {
      "title": "Folders",
      "add": "Add folder",
      "addTitle": "New folder",
      "renameTitle": "Rename folder",
      "name": "Folder name",
      "namePlaceholder": "e.g. Lease agreements",
      "rename": "rename",
      "remove": "delete folder",
      "removeTitle": "Delete folder",
      "removeConfirm": "“{{name}}” will leave the list. The folder is empty — it is archived, not erased.",
      "notEmptyHint": "It holds {{count}} documents — move or archive them first.",
      "saved": "Folder saved",
      "removed": "Folder removed"
    },
    "uploadForm": {
      "title": "Upload document",
      "subtitle": "Up to {{size}} MB per file · PDF, images, Office, text",
      "pick": "Choose files",
      "pickMore": "Add files",
      "pickHint": "Drag files onto this area, or pick them with “Choose files”.",
      "start": "Upload",
      "startCount": "Upload {{count}} files",
      "stop": "Stop uploading",
      "stopHint": "Queued files are skipped; the one in flight finishes.",
      "progress": "{{done}} / {{total}} uploaded",
      "leaveWarning": "Upload in progress — leave the page and the remaining files are not uploaded.",
      "remove": "remove from list",
      "status": {
        "waiting": "waiting",
        "uploading": "uploading…",
        "done": "uploaded",
        "error": "failed",
        "skipped": "stopped"
      },
      "tooBig": "The file is over the {{size}} MB limit.",
      "unsupported": "This file type cannot be uploaded.",
      "done": "{{count}} documents uploaded",
      "partial": "{{done}} uploaded, {{failed}} failed.",
      "stopped": "{{done}} uploaded, {{count}} stopped — “Yükle” picks up where it left off."
    },
    "viewer": {
      "newTab": "Open in new tab",
      "pdfTitle": "{{name}} — document preview",
      "pdfHint": "If the preview looks empty your browser does not open PDFs inline: use “İndir” or “Yeni sekmede aç”.",
      "zoom": "Image size",
      "fit": "Fit",
      "actual": "Actual size",
      "noPreview": "This file type cannot be shown in the app. Download it to open it on your device, or share it.",
      "imageFailed": "The browser could not decode this image (HEIC, TIFF and the like). It opens once downloaded.",
      "textTooBig": "The file is too large to preview (over {{limit}} KB). Download it to read it.",
      "saved": "Document updated"
    },
    "sharing": {
      "warningTitle": "Anyone with the link can open it",
      "warning": "Anyone who opens this link can see the document until it expires — no sign-in and no membership needed. Send it only to the person you mean to.",
      "duration": "Link lifetime",
      "hour": "1 hour",
      "day": "1 day",
      "week": "7 days",
      "create": "Create link and copy",
      "again": "Create a new link",
      "link": "Share link",
      "expires": "The link works until {{time}}. If it was not copied, select the field and copy it."
    }
  },
  "market": {
    "title": "Markets",
    "settingLabel": "Market strip",
    "settingHint": "Dollar, euro, pound, gram gold and BIST 100 scroll across the top of the screen. Daily closing figures — not for booking.",
    "asOf": "{{date}} close",
    "source": {
      "TCMB": "TCMB",
      "EVDS": "TCMB EVDS",
      "MANUAL": "Entered by hand"
    }
  }
}
